// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import React from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faEllipsisV,
  faEye,
  faSnowflake,
  faMapMarker,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import { encodedUrlBuliding } from "../../services/utilities/util";
import { Table } from "react-infinite-table";
import FilterContext from "../../routes/FilterContext";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "react-infinite-table/dist/style.css";
import { Link } from "react-router-dom";
import md5 from "md5";
import { saveAs } from "file-saver";
// import DatePicker from "react-datepicker";
import DatePicker from "rsuite/DatePicker";
// import "react-datepicker/dist/react-datepicker.css";
// const N_ROWS = 10 ** 3;
// const INFINITE_SCROLLING_N_ROWS = 30;
const N_COLS = 20;

export const BodyAsFormData1 = (col) => {
  var body = new FormData();
  body.append("colPref", col);
  body.append("screener", "edge_office");
  return body;
};

export const BodyAsFormData2 = () => {
  var body = new FormData();
  body.append("screener", "edge_office");
  return body;
};

export const BodyAsFormDataSaleCol = () => {
  var body = new FormData();
  body.append("screener", "edge_office_sales");
  return body;
};

export const BodyAsFormData3 = (page, date, filter) => {
  var body = new FormData();
  body.append("page", page);
  body.append("futureRentDate", date);
  body.append("filter", filter);
  return body;
};

export const logActivityBody = (filter, csvSelectedData, count) => {
  var body = new FormData();
  body.append("path", "/edge/office/transaction");
  body.append("hash", filter);
  body.append("action", "export");
  body.append("extra_data", csvSelectedData);
  body.append("count", count);
  return body;
};

export const BodyAsFormDataWithSort = (
  page,
  date,
  filter,
  sortBy,
  sortOrder
) => {
  var body = new FormData();
  body.append("page", page);
  body.append("futureRentDate", date);
  body.append("filter", filter);
  body.append("sortBy", sortBy);
  body.append("sortOrder", sortOrder);
  return body;
};

export const BodyAsFormData4 = (creId) => {
  var body = new FormData();
  body.append("creID", creId);
  body.append("screener", "lease");
  return body;
};

function mapStateToProps(state) {
  return {
    filters: state.selectedFilters,
    downloadOption: state.downloadOptions,
    user_id: state.user_id,
  };
}

class Transactions extends React.Component {
  static contextType = FilterContext;
  state = {
    errorMessage: `You do not have enough privileges to download data
                        Kindly contact
                        <a href="mailto:info@crematrix.com">
                          info@crematrix.com
                        </a>`,
    load: false,
    sortBy: null,
    sortOrder: null,
    showImageLoader: false,
    startDate: new Date(),
    futureRentDate: new Date().toISOString().split("T")[0],
    averages: [],
    headerUnits: [],
    page: 1,
    transactionData: [],
    noRows: false,
    numberOfColumns: N_COLS,
    columns: [],
    fixedColumnsCount: 2,
    fillTableWidth: false,
    displayBottomUpwards: false,
    infiniteScrolling: true,
    rows: [],
    rowIdKey: "",
    isInfiniteLoading: false,
    selectedRows: {},
    canSelectMultipleRows: true,
    filters: "",
    isOpen: false,
    isOpenDocModal: false,
    isOpenColumnsModal: false,
    isOpenExcelModal: false,
    isOpenPngModal: false,
    isOpenTimeModal: false,
    isOpenNotesModal: false,
    showDerivedCols: true,
    selectAll: true,
    isOpenDownloadModal: false,
    currentArray: [],
    dragArray: [],
    dropdownTxt: "Hide Derived Data",
    creId: "",
    creIdDoc: "",
    numPages: "",
    pageNumber: 1,
    docUrl: "",
    downloadColumns: [],
    checkedCsvCol: [],
    imgPath: "",
    isOpenErrorDisplayModal: false,

    //Sale State Variables

    loadSale: false,
    sortBySale: null,
    sortOrderSale: null,
    showImageLoaderSale: false,
    startDateSale: new Date(),
    futureRentDateSale: new Date().toISOString().split("T")[0],
    averagesSale: [],
    headerUnitsSale: [],
    pageSale: 1,
    transactionDataSale: [],
    noRowsSale: false,
    numberOfColumnsSale: N_COLS,
    columnsSale: [],
    fixedColumnsCountSale: 2,
    fillTableWidthSale: false,
    displayBottomUpwardsSale: false,
    infiniteScrollingSale: true,
    rowsSale: [],
    rowIdKeySale: "",
    isInfiniteLoadingSale: false,
    selectedRowsSale: {},
    canSelectMultipleRowsSale: true,
    isOpenSale: false,
    isOpenDocModalSale: false,
    isOpenColumnsModalSale: false,
    isOpenExcelModalSale: false,
    isOpenPngModalSale: false,
    isOpenTimeModalSale: false,
    isOpenNotesModalSale: false,
    showDerivedColsSale: true,
    selectAllSale: true,
    isOpenDownloadModalSale: false,
    currentArraySale: [],
    dragArraySale: [],
    dropdownTxtSale: "Hide Derived Data",
    downloadColumnsSale: [],
    checkedCsvColSale: [],
    imgPathSale: "",
    isOpenErrorDisplayModalSale: false,
  };
  constructor(props) {
    console.log(props);
    super(props);
  }
  linkingUrl(columnName, columnData) {
    // console.log(columnName, columnData);
    if (columnName == "Complex") {
      return (
        <Link target="_blank" to={encodedUrlBuliding("complex", columnData)}>
          {columnData}
        </Link>
      );
    } else if (columnName == "Tenant") {
      return (
        <Link target="_blank" to={encodedUrlBuliding("tenant", columnData)}>
          {columnData}
        </Link>
      );
    } else if (columnName == "Micro Market") {
      return (
        <Link
          target="_blank"
          to={encodedUrlBuliding("micromarket", columnData)}
        >
          {columnData}
        </Link>
      );
    } else if (columnName == "Developer") {
      return (
        <Link target="_blank" to={encodedUrlBuliding("developer", columnData)}>
          {columnData}
        </Link>
      );
    } else if (columnName == "Market") {
      return (
        <Link target="_blank" to={encodedUrlBuliding("city", columnData)}>
          {columnData}
        </Link>
      );
    } else if (columnName == "Macro Market") {
      return (
        <Link
          target="_blank"
          to={encodedUrlBuliding("macromarket", columnData)}
        >
          {columnData}
        </Link>
      );
    } else if (columnName == "Landlord") {
      return (
        <Link target="_blank" to={encodedUrlBuliding("owner", columnData)}>
          {columnData}
        </Link>
      );
    } else if (columnName == "View on Map") {
      return (
        <a target="_blank" href={columnData}>
          <FontAwesomeIcon icon={faMapMarker} height="500" width="500" />
        </a>
      );
    } else if (columnName == "Select") {
      return (
        <Link target="_blank" to={encodedUrlBuliding("leaseId", columnData)}>
          <FontAwesomeIcon icon={faEye} />
        </Link>
      );
    } else {
      return columnData;
    }
  }

  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {});
    this.setState({ load: true });
    // apiMiddleware
    //   .post("api/edge/office/get_user_col_pref", BodyAsFormData2())
    //   .then((res) => {
    //     this.setState(
    //       {
    //         currentArray: JSON.parse(res.data[0].preference),
    //         dragArray: JSON.parse(res.data[0].preference),
    //         downloadColumns: JSON.parse(res.data[0].preference),
    //       },
    //       () => {
    //         let csvData = JSON.parse(res.data[0].preference);
    //         let colNameArr = [];
    //         for (let i = 0; i < csvData.length; i++) {
    //           colNameArr.push(csvData[i].name);
    //         }
    //         this.setState({ checkedCsvCol: colNameArr }, () => {});
    //         var filters;
    //         if (JSON.stringify(this.props.filters) == "{}") {
    //           filters = JSON.stringify(this.context.filters);
    //         } else {
    //           filters = JSON.stringify(this.props.filters);
    //         }
    //         this.state.filters = filters;
    //         apiMiddleware
    //           .post(
    //             "api/edge/office/get_lease_transactions",
    //             BodyAsFormData3(
    //               this.state.page,
    //               this.state.futureRentDate,
    //               this.state.filters
    //             )
    //           )
    //           .then((res) => {
    //             this.setState({
    //               averages: res.data.averages,
    //               headerUnits: res.data.columns.unit,
    //             });
    //             var columns = [];

    //             var visibleColumns = this.state.dragArray.filter(function (
    //               obj
    //             ) {
    //               return obj.visible === true;
    //             });
    //             var columns = visibleColumns.map((elem) => elem.name);
    //             columns.unshift("Select");
    //             var _columns = [];

    //             for (let index = 0; index < columns.length; index++) {
    //               _columns.push({
    //                 i: index,
    //                 cellRenderer: ({
    //                   columnIndex,
    //                   column,
    //                   rowData,
    //                   rowIndex,
    //                   className,
    //                 }) => {
    //                   var derived = [];
    //                   try {
    //                     derived = JSON.parse(rowData.derived_columns);
    //                   } catch (e) {
    //                     derived = [];
    //                   }
    //                   if (
    //                     this.state.showDerivedCols == true &&
    //                     derived.indexOf(columns[index]) > -1
    //                   ) {
    //                     return (
    //                       <td
    //                         className={className}
    //                         style={{ background: "#ff9515", color: "#FFF" }}
    //                       >
    //                         {rowData[columns[index]]}
    //                       </td>
    //                     );
    //                   } else {
    //                     if (
    //                       columns[index] == "Download" &&
    //                       rowData["Download"] === 1
    //                     ) {
    //                       return (
    //                         <td
    //                           className={className}
    //                           onClick={(e) => {
    //                             this.downloadRowData(rowData["CRE ID"]);
    //                           }}
    //                         >
    //                           {<FontAwesomeIcon icon={faArrowDown} />}
    //                         </td>
    //                       );
    //                     } else if (
    //                       columns[index] == "Download" &&
    //                       rowData["Download"] === 0
    //                     ) {
    //                       return <td className={className}>{"-"}</td>;
    //                     } else if (
    //                       columns[index] == "View Document" &&
    //                       rowData["View Document"] === 1
    //                     ) {
    //                       return (
    //                         <td className={className}>
    //                           {
    //                             <Link
    //                               to="#"
    //                               onClick={(e) => {
    //                                 this.openModalDoc(rowData["CRE ID"]);
    //                               }}
    //                             >
    //                               View
    //                             </Link>
    //                           }
    //                         </td>
    //                       );
    //                     } else if (
    //                       columns[index] == "View Document" &&
    //                       rowData["View Document"] === 0
    //                     ) {
    //                       return <td className={className}>{"-"}</td>;
    //                     } else {
    //                       return (
    //                         <td
    //                           className={className}
    //                           title={rowData[columns[index]]}
    //                         >
    //                           {this.linkingUrl(
    //                             columns[index],
    //                             rowData[columns[index]]
    //                           )}
    //                         </td>
    //                       );
    //                     }
    //                   }
    //                 },
    //                 headerRenderer: ({ columnIndex, column, className }) => {
    //                   if (columns[index] == "Select") {
    //                     return (
    //                       <th className={className}>
    //                         View
    //                         <p>{this.state.headerUnits[columns[index]]}</p>
    //                       </th>
    //                     );
    //                   } else {
    //                     return (
    //                       <th className={className}>
    //                         {this.headerView(
    //                           columns[index],
    //                           this.state.headerUnits[columns[index]]
    //                         )}
    //                       </th>
    //                     );
    //                   }
    //                 },
    //                 footerRenderer: ({ columnIndex, column, className }) => {
    //                   if (this.state.averages[columns[index]] != undefined) {
    //                     return (
    //                       <td className={className}>
    //                         {this.state.averages[columns[index]].avg}
    //                       </td>
    //                     );
    //                   } else {
    //                     return <td></td>;
    //                   }
    //                 },

    //                 width: 100,
    //               });
    //             }
    //             this.setState({
    //               columns: _columns,
    //             });
    //             this.setState({ rows: res.data.rows });
    //             this.setState({ transactionData: res.data });
    //           });
    //         let fixedColCount = 0;
    //         for (let i = 0; i < this.state.dragArray.length; i++) {
    //           if (
    //             this.state.dragArray[i].static == true &&
    //             this.state.dragArray[i].visible == true
    //           ) {
    //             fixedColCount = fixedColCount + 1;
    //           }
    //           this.setState({ fixedColumnsCount: fixedColCount + 1 });
    //         }
    //       }
    //     );
    //   });

    //sale

    // apiMiddleware
    //   .post("api/edge/office/get_user_col_pref", BodyAsFormDataSaleCol())
    //   .then((res) => {
    //     this.setState(
    //       {
    //         currentArraySale: JSON.parse(res.data[0].preference),
    //         dragArraySale: JSON.parse(res.data[0].preference),
    //         downloadColumnsSale: JSON.parse(res.data[0].preference),
    //       },
    //       () => {
    //         let csvData = JSON.parse(res.data[0].preference);
    //         let colNameArr = [];
    //         for (let i = 0; i < csvData.length; i++) {
    //           colNameArr.push(csvData[i].name);
    //         }
    //         this.setState({ checkedCsvColSale: colNameArr }, () => {});

    //         apiMiddleware
    //           .post(
    //             "api/edge/office/get_sales_transactions",
    //             BodyAsFormDataWithSort(
    //               this.state.pageSale,
    //               this.state.futureRentDateSale,
    //               JSON.stringify(this.props.filters),
    //               this.state.sortBySale,
    //               this.state.sortOrderSale
    //             )
    //           )
    //           .then((res) => {
    //             this.setState({
    //               averagesSale: res.data.averages,
    //               headerUnitsSale: res.data.columns.unit,
    //             });
    //             var columns = [];

    //             var visibleColumns = this.state.dragArraySale.filter(function (
    //               obj
    //             ) {
    //               return obj.visible === true;
    //             });
    //             var columns = visibleColumns.map((elem) => elem.name);
    //             columns.unshift("Select");
    //             var _columns = [];

    //             for (let index = 0; index < columns.length; index++) {
    //               _columns.push({
    //                 i: index,
    //                 cellRenderer: ({
    //                   columnIndex,
    //                   column,
    //                   rowData,
    //                   rowIndex,
    //                   className,
    //                 }) => {
    //                   var derived = [];
    //                   try {
    //                     derived = JSON.parse(rowData.derived_columns);
    //                   } catch (e) {
    //                     derived = [];
    //                   }
    //                   if (
    //                     this.state.showDerivedColsSale == true &&
    //                     derived.indexOf(columns[index]) > -1
    //                   ) {
    //                     return (
    //                       <td
    //                         className={className}
    //                         style={{ background: "#ff9515", color: "#FFF" }}
    //                       >
    //                         {rowData[columns[index]]}
    //                       </td>
    //                     );
    //                   } else {
    //                     if (
    //                       columns[index] == "Download" &&
    //                       rowData["Download"] === 1
    //                     ) {
    //                       return (
    //                         <td
    //                           className={className}
    //                           onClick={(e) => {
    //                             this.downloadRowDataSale(rowData["CRE ID"]);
    //                           }}
    //                         >
    //                           {<FontAwesomeIcon icon={faArrowDown} />}
    //                         </td>
    //                       );
    //                     } else if (
    //                       columns[index] == "Download" &&
    //                       rowData["Download"] === 0
    //                     ) {
    //                       return <td className={className}>{"-"}</td>;
    //                     } else if (
    //                       columns[index] == "View Document" &&
    //                       rowData["View Document"] === 1
    //                     ) {
    //                       return (
    //                         <td className={className}>
    //                           {
    //                             <Link
    //                               to="#"
    //                               onClick={(e) => {
    //                                 this.openModalDoc(rowData["CRE ID"]);
    //                               }}
    //                             >
    //                               View
    //                             </Link>
    //                           }
    //                         </td>
    //                       );
    //                     } else if (
    //                       columns[index] == "View Document" &&
    //                       rowData["View Document"] === 0
    //                     ) {
    //                       return <td className={className}>{"-"}</td>;
    //                     } else {
    //                       return (
    //                         <td
    //                           className={className}
    //                           title={rowData[columns[index]]}
    //                         >
    //                           {this.linkingUrl(
    //                             columns[index],
    //                             rowData[columns[index]]
    //                           )}
    //                         </td>
    //                       );
    //                     }
    //                   }
    //                 },
    //                 headerRenderer: ({ columnIndex, column, className }) => {
    //                   if (columns[index] == "Select") {
    //                     return (
    //                       <th className={className}>
    //                         View
    //                         <p>{this.state.headerUnitsSale[columns[index]]}</p>
    //                       </th>
    //                     );
    //                   } else {
    //                     return (
    //                       <th className={className}>
    //                         <p>
    //                           {this.headerView(
    //                             columns[index],
    //                             this.state.headerUnitsSale[columns[index]]
    //                           )}
    //                         </p>
    //                       </th>
    //                     );
    //                   }
    //                 },
    //                 footerRenderer: ({ columnIndex, column, className }) => {
    //                   if (
    //                     this.state.averagesSale[columns[index]] != undefined
    //                   ) {
    //                     return (
    //                       <td className={className}>
    //                         {this.state.averagesSale[columns[index]].avg}
    //                       </td>
    //                     );
    //                   } else {
    //                     return <td></td>;
    //                   }
    //                 },

    //                 width: 100,
    //               });
    //             }
    //             this.setState({
    //               columnsSale: _columns,
    //             });
    //             this.setState({ rowsSale: res.data.rows });
    //             this.setState({ transactionDataSale: res.data });
    //           });
    //         let fixedColCountSale = 0;
    //         for (let i = 0; i < this.state.dragArray.length; i++) {
    //           if (
    //             this.state.dragArray[i].static == true &&
    //             this.state.dragArray[i].visible == true
    //           ) {
    //             fixedColCountSale = fixedColCountSale + 1;
    //           }
    //           this.setState({ fixedColumnsCountSale: fixedColCountSale + 1 });
    //         }
    //       }
    //     );
    //   });
  }

  fetchNewData() {
    apiMiddleware
      .post(
        "api/edge/office/get_lease_transactions",
        BodyAsFormDataWithSort(
          this.state.page,
          this.state.futureRentDate,
          JSON.stringify(this.state.filters),
          this.state.sortBy,
          this.state.sortOrder
        )
      )
      .then((res) => {
        this.setState({
          averages: res.data.averages,
          headerUnits: res.data.columns.unit,
        });
        var columns = [];

        var visibleColumns = this.state.dragArray.filter(function (obj) {
          return obj.visible === true;
        });
        var columns = visibleColumns.map((elem) => elem.name);
        columns.unshift("Select");
        var _columns = [];

        for (let index = 0; index < columns.length; index++) {
          _columns.push({
            i: index,
            cellRenderer: ({
              columnIndex,
              column,
              rowData,
              rowIndex,
              className,
            }) => {
              var derived = [];
              try {
                derived = JSON.parse(rowData.derived_columns);
              } catch (e) {
                derived = [];
              }
              if (
                this.state.showDerivedCols == true &&
                derived.indexOf(columns[index]) > -1
              ) {
                return (
                  <td
                    className={className}
                    style={{ background: "#ff9515", color: "#FFF" }}
                  >
                    {rowData[columns[index]]}
                  </td>
                );
              } else {
                if (columns[index] == "Download" && rowData["Download"] === 1) {
                  return (
                    <td
                      className={className}
                      onClick={(e) => {
                        this.downloadRowData(rowData["CRE ID"]);
                      }}
                    >
                      {<FontAwesomeIcon icon={faArrowDown} />}
                    </td>
                  );
                } else if (
                  columns[index] == "Download" &&
                  rowData["Download"] === 0
                ) {
                  return <td className={className}>{"-"}</td>;
                } else if (
                  columns[index] == "View Document" &&
                  rowData["View Document"] === 1
                ) {
                  return (
                    <td className={className}>
                      {
                        <Link
                          to="#"
                          onClick={(e) => {
                            this.openModalDoc(rowData["CRE ID"]);
                          }}
                        >
                          View
                        </Link>
                      }
                    </td>
                  );
                } else if (
                  columns[index] == "View Document" &&
                  rowData["View Document"] === 0
                ) {
                  return <td className={className}>{"-"}</td>;
                } else {
                  return (
                    <td className={className} title={rowData[columns[index]]}>
                      {this.linkingUrl(columns[index], rowData[columns[index]])}
                    </td>
                  );
                }
              }
            },
            headerRenderer: ({ columnIndex, column, className }) => {
              if (columns[index] == "Select") {
                return (
                  <th className={className}>
                    View
                    <p>{this.state.headerUnits[columns[index]]}</p>
                  </th>
                );
              } else {
                return (
                  <th className={className}>
                    {this.headerView(
                      columns[index],
                      this.state.headerUnits[columns[index]]
                    )}
                  </th>
                );
              }
            },
            footerRenderer: ({ columnIndex, column, className }) => {
              if (this.state.averages[columns[index]] != undefined) {
                return (
                  <td className={className}>
                    {this.state.averages[columns[index]].avg}
                  </td>
                );
              } else {
                return <td></td>;
              }
            },

            width: 100,
          });
        }
        this.setState({
          columns: _columns,
        });
        this.setState({ rows: res.data.rows });
        this.setState({ transactionData: res.data });
      });
    let fixedColCount = 0;
    for (let i = 0; i < this.state.dragArray.length; i++) {
      if (
        this.state.dragArray[i].static == true &&
        this.state.dragArray[i].visible == true
      ) {
        fixedColCount = fixedColCount + 1;
      }
      this.setState({ fixedColumnsCount: fixedColCount + 1 });
    }
  }

  fetchNewDataSale() {
    apiMiddleware
      .post(
        "api/edge/office/get_sales_transactions",
        BodyAsFormDataWithSort(
          this.state.pageSale,
          this.state.futureRentDateSale,
          JSON.stringify(this.state.filters),
          this.state.sortBySale,
          this.state.sortOrderSale
        )
      )
      .then((res) => {
        this.setState({
          averagesSale: res.data.averages,
          headerUnitsSale: res.data.columns.unit,
        });
        var columns = [];

        var visibleColumns = this.state.dragArraySale.filter(function (obj) {
          return obj.visible === true;
        });
        var columns = visibleColumns.map((elem) => elem.name);
        columns.unshift("Select");
        var _columns = [];

        for (let index = 0; index < columns.length; index++) {
          _columns.push({
            i: index,
            cellRenderer: ({
              columnIndex,
              column,
              rowData,
              rowIndex,
              className,
            }) => {
              var derived = [];
              try {
                derived = JSON.parse(rowData.derived_columns);
              } catch (e) {
                derived = [];
              }
              if (
                this.state.showDerivedColsSale == true &&
                derived.indexOf(columns[index]) > -1
              ) {
                return (
                  <td
                    className={className}
                    style={{ background: "#ff9515", color: "#FFF" }}
                  >
                    {rowData[columns[index]]}
                  </td>
                );
              } else {
                if (columns[index] == "Download" && rowData["Download"] === 1) {
                  return (
                    <td
                      className={className}
                      onClick={(e) => {
                        this.downloadRowDataSale(rowData["CRE ID"]);
                      }}
                    >
                      {<FontAwesomeIcon icon={faArrowDown} />}
                    </td>
                  );
                } else if (
                  columns[index] == "Download" &&
                  rowData["Download"] === 0
                ) {
                  return <td className={className}>{"-"}</td>;
                } else if (
                  columns[index] == "View Document" &&
                  rowData["View Document"] === 1
                ) {
                  return (
                    <td className={className}>
                      {
                        <Link
                          to="#"
                          onClick={(e) => {
                            this.openModalDoc(rowData["CRE ID"]);
                          }}
                        >
                          View
                        </Link>
                      }
                    </td>
                  );
                } else if (
                  columns[index] == "View Document" &&
                  rowData["View Document"] === 0
                ) {
                  return <td className={className}>{"-"}</td>;
                } else {
                  return (
                    <td className={className} title={rowData[columns[index]]}>
                      {this.linkingUrl(columns[index], rowData[columns[index]])}
                    </td>
                  );
                }
              }
            },
            headerRenderer: ({ columnIndex, column, className }) => {
              if (columns[index] == "Select") {
                return (
                  <th className={className}>
                    View
                    <p>{this.state.headerUnitsSale[columns[index]]}</p>
                  </th>
                );
              } else {
                return (
                  <th className={className}>
                    {this.headerView(
                      columns[index],
                      this.state.headerUnitsSale[columns[index]]
                    )}
                  </th>
                );
              }
            },
            footerRenderer: ({ columnIndex, column, className }) => {
              if (this.state.averagesSale[columns[index]] != undefined) {
                return (
                  <td className={className}>
                    {this.state.averagesSale[columns[index]].avg}
                  </td>
                );
              } else {
                return <td></td>;
              }
            },

            width: 100,
          });
        }
        this.setState({
          columnsSale: _columns,
        });
        this.setState({ rowsSale: res.data.rows });
        this.setState({ transactionDataSale: res.data });
      });
    let fixedColCount = 0;
    for (let i = 0; i < this.state.dragArraySale.length; i++) {
      if (
        this.state.dragArraySale[i].static == true &&
        this.state.dragArraySale[i].visible == true
      ) {
        fixedColCount = fixedColCount + 1;
      }
      this.setState({ fixedColumnsCountSale: fixedColCount + 1 });
    }
  }

  headerView(header, unit) {
    return (
      <div
        onClick={() => {
          if (this.state.sortBy != header) {
            this.setState(
              {
                sortBy: header,
                sortOrder: "asc",
                page: 1,
              },
              () => {
                this.fetchNewData();
              }
            );
          } else {
            if (this.state.sortOrder == "asc") {
              this.setState(
                {
                  sortOrder: "desc",
                  page: 1,
                },
                () => {
                  this.fetchNewData();
                }
              );
            } else {
              this.setState(
                {
                  sortOrder: "asc",
                  page: 1,
                },
                () => {
                  this.fetchNewData();
                }
              );
            }
          }
        }}
      >
        <div>
          {header}{" "}
          {header == this.state.sortBy ? (
            this.state.sortOrder == "asc" ? (
              <FontAwesomeIcon icon={faArrowDown} />
            ) : (
              <FontAwesomeIcon icon={faArrowUp} />
            )
          ) : (
            <></>
          )}{" "}
          <p> {unit} </p>
        </div>
      </div>
    );
  }

  headerViewSale(header, unit) {
    return (
      <div
        onClick={() => {
          if (this.state.sortBySale != header) {
            this.setState(
              {
                sortBySale: header,
                sortOrderSale: "asc",
                pageSale: 1,
              },
              () => {
                this.fetchNewDataSale();
              }
            );
          } else {
            if (this.state.sortOrderSale == "asc") {
              this.setState(
                {
                  sortOrderSale: "desc",
                  pageSale: 1,
                },
                () => {
                  this.fetchNewDataSale();
                }
              );
            } else {
              this.setState(
                {
                  sortOrderSale: "asc",
                  pageSale: 1,
                },
                () => {
                  this.fetchNewDataSale();
                }
              );
            }
          }
        }}
      >
        <div>
          {header}{" "}
          {header == this.state.sortBySale ? (
            this.state.sortOrderSale == "asc" ? (
              <FontAwesomeIcon icon={faArrowDown} />
            ) : (
              <FontAwesomeIcon icon={faArrowUp} />
            )
          ) : (
            <></>
          )}{" "}
          <p> {unit} </p>
        </div>
      </div>
    );
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });
      apiMiddleware
        .post("api/edge/office/get_user_col_pref", BodyAsFormData2())
        .then((res) => {
          this.setState(
            {
              currentArray: JSON.parse(res.data[0].preference),
              dragArray: JSON.parse(res.data[0].preference),
              downloadColumns: JSON.parse(res.data[0].preference),
              // currentArraySale: JSON.parse(res.data[0].preference),
              // dragArraySale: JSON.parse(res.data[0].preference),
              // downloadColumnsSale: JSON.parse(res.data[0].preference),
            },
            () => {
              let csvData = JSON.parse(res.data[0].preference);
              let colNameArr = [];
              for (let i = 0; i < csvData.length; i++) {
                colNameArr.push(csvData[i].name);
              }
              this.setState(
                { checkedCsvCol: colNameArr, checkedCsvColSale: colNameArr },
                () => {}
              );

              apiMiddleware
                .post(
                  "api/edge/office/get_lease_transactions",
                  BodyAsFormDataWithSort(
                    this.state.page,
                    this.state.futureRentDate,
                    JSON.stringify(this.props.filters),
                    this.state.sortBy,
                    this.state.sortOrder
                  )
                )
                .then((res) => {
                  this.setState({
                    averages: res.data.averages,
                    headerUnits: res.data.columns.unit,
                  });
                  var columns = [];

                  var visibleColumns = this.state.dragArray.filter(function (
                    obj
                  ) {
                    return obj.visible === true;
                  });
                  var columns = visibleColumns.map((elem) => elem.name);
                  columns.unshift("Select");
                  var _columns = [];

                  for (let index = 0; index < columns.length; index++) {
                    _columns.push({
                      i: index,
                      cellRenderer: ({
                        columnIndex,
                        column,
                        rowData,
                        rowIndex,
                        className,
                      }) => {
                        var derived = [];
                        try {
                          derived = JSON.parse(rowData.derived_columns);
                        } catch (e) {
                          derived = [];
                        }
                        if (
                          this.state.showDerivedCols == true &&
                          derived.indexOf(columns[index]) > -1
                        ) {
                          return (
                            <td
                              className={className}
                              style={{ background: "#ff9515", color: "#FFF" }}
                            >
                              {rowData[columns[index]]}
                            </td>
                          );
                        } else {
                          if (
                            columns[index] == "Download" &&
                            rowData["Download"] === 1
                          ) {
                            return (
                              <td
                                className={className}
                                onClick={(e) => {
                                  this.downloadRowData(rowData["CRE ID"]);
                                }}
                              >
                                {<FontAwesomeIcon icon={faArrowDown} />}
                              </td>
                            );
                          } else if (
                            columns[index] == "Download" &&
                            rowData["Download"] === 0
                          ) {
                            return <td className={className}>{"-"}</td>;
                          } else if (
                            columns[index] == "View Document" &&
                            rowData["View Document"] === 1
                          ) {
                            return (
                              <td className={className}>
                                {
                                  <Link
                                    to="#"
                                    onClick={(e) => {
                                      this.openModalDoc(rowData["CRE ID"]);
                                    }}
                                  >
                                    View
                                  </Link>
                                }
                              </td>
                            );
                          } else if (
                            columns[index] == "View Document" &&
                            rowData["View Document"] === 0
                          ) {
                            return <td className={className}>{"-"}</td>;
                          } else {
                            return (
                              <td
                                className={className}
                                title={rowData[columns[index]]}
                              >
                                {this.linkingUrl(
                                  columns[index],
                                  rowData[columns[index]]
                                )}
                              </td>
                            );
                          }
                        }
                      },
                      headerRenderer: ({ columnIndex, column, className }) => {
                        if (columns[index] == "Select") {
                          return (
                            <th className={className}>
                              View
                              <p>{this.state.headerUnits[columns[index]]}</p>
                            </th>
                          );
                        } else {
                          return (
                            <th className={className}>
                              <p>
                                {this.headerView(
                                  columns[index],
                                  this.state.headerUnits[columns[index]]
                                )}
                              </p>
                            </th>
                          );
                        }
                      },
                      footerRenderer: ({ columnIndex, column, className }) => {
                        if (this.state.averages[columns[index]] != undefined) {
                          return (
                            <td className={className}>
                              {this.state.averages[columns[index]].avg}
                            </td>
                          );
                        } else {
                          return <td></td>;
                        }
                      },

                      width: 100,
                    });
                  }
                  this.setState({
                    columns: _columns,
                  });
                  this.setState({ rows: res.data.rows });
                  this.setState({ transactionData: res.data });
                });
              let fixedColCount = 0;
              for (let i = 0; i < this.state.dragArray.length; i++) {
                if (
                  this.state.dragArray[i].static == true &&
                  this.state.dragArray[i].visible == true
                ) {
                  fixedColCount = fixedColCount + 1;
                }
                this.setState({ fixedColumnsCount: fixedColCount + 1 });
              }
            }
          );
        });

      apiMiddleware
        .post("api/edge/office/get_user_col_pref", BodyAsFormDataSaleCol())
        .then((res) => {
          this.setState(
            {
              currentArraySale: JSON.parse(res.data[0].preference),
              dragArraySale: JSON.parse(res.data[0].preference),
              downloadColumnsSale: JSON.parse(res.data[0].preference),
            },
            () => {
              let csvData = JSON.parse(res.data[0].preference);
              let colNameArr = [];
              for (let i = 0; i < csvData.length; i++) {
                colNameArr.push(csvData[i].name);
              }
              this.setState({ checkedCsvColSale: colNameArr }, () => {});

              apiMiddleware
                .post(
                  "api/edge/office/get_sales_transactions",
                  BodyAsFormDataWithSort(
                    this.state.pageSale,
                    this.state.futureRentDateSale,
                    JSON.stringify(this.props.filters),
                    this.state.sortBySale,
                    this.state.sortOrderSale
                  )
                )
                .then((res) => {
                  this.setState({
                    averagesSale: res.data.averages,
                    headerUnitsSale: res.data.columns.unit,
                  });
                  var columns = [];

                  var visibleColumns = this.state.dragArraySale.filter(
                    function (obj) {
                      return obj.visible === true;
                    }
                  );
                  var columns = visibleColumns.map((elem) => elem.name);
                  columns.unshift("Select");
                  var _columns = [];

                  for (let index = 0; index < columns.length; index++) {
                    _columns.push({
                      i: index,
                      cellRenderer: ({
                        columnIndex,
                        column,
                        rowData,
                        rowIndex,
                        className,
                      }) => {
                        var derived = [];
                        try {
                          derived = JSON.parse(rowData.derived_columns);
                        } catch (e) {
                          derived = [];
                        }
                        if (
                          this.state.showDerivedColsSale == true &&
                          derived.indexOf(columns[index]) > -1
                        ) {
                          return (
                            <td
                              className={className}
                              style={{ background: "#ff9515", color: "#FFF" }}
                            >
                              {rowData[columns[index]]}
                            </td>
                          );
                        } else {
                          if (
                            columns[index] == "Download" &&
                            rowData["Download"] === 1
                          ) {
                            return (
                              <td
                                className={className}
                                onClick={(e) => {
                                  this.downloadRowDataSale(rowData["CRE ID"]);
                                }}
                              >
                                {<FontAwesomeIcon icon={faArrowDown} />}
                              </td>
                            );
                          } else if (
                            columns[index] == "Download" &&
                            rowData["Download"] === 0
                          ) {
                            return <td className={className}>{"-"}</td>;
                          } else if (
                            columns[index] == "View Document" &&
                            rowData["View Document"] === 1
                          ) {
                            return (
                              <td className={className}>
                                {
                                  <Link
                                    to="#"
                                    onClick={(e) => {
                                      this.openModalDoc(rowData["CRE ID"]);
                                    }}
                                  >
                                    View
                                  </Link>
                                }
                              </td>
                            );
                          } else if (
                            columns[index] == "View Document" &&
                            rowData["View Document"] === 0
                          ) {
                            return <td className={className}>{"-"}</td>;
                          } else {
                            return (
                              <td
                                className={className}
                                title={rowData[columns[index]]}
                              >
                                {this.linkingUrl(
                                  columns[index],
                                  rowData[columns[index]]
                                )}
                              </td>
                            );
                          }
                        }
                      },
                      headerRenderer: ({ columnIndex, column, className }) => {
                        if (columns[index] == "Select") {
                          return (
                            <th className={className}>
                              View
                              <p>
                                {this.state.headerUnitsSale[columns[index]]}
                              </p>
                            </th>
                          );
                        } else {
                          return (
                            <th className={className}>
                              <p>
                                {this.headerView(
                                  columns[index],
                                  this.state.headerUnitsSale[columns[index]]
                                )}
                              </p>
                            </th>
                          );
                        }
                      },
                      footerRenderer: ({ columnIndex, column, className }) => {
                        if (
                          this.state.averagesSale[columns[index]] != undefined
                        ) {
                          return (
                            <td className={className}>
                              {this.state.averagesSale[columns[index]].avg}
                            </td>
                          );
                        } else {
                          return <td></td>;
                        }
                      },

                      width: 100,
                    });
                  }
                  this.setState({
                    columnsSale: _columns,
                  });
                  this.setState({ rowsSale: res.data.rows });
                  this.setState({ transactionDataSale: res.data });
                });
              let fixedColCountSale = 0;
              for (let i = 0; i < this.state.dragArraySale.length; i++) {
                if (
                  this.state.dragArraySale[i].static == true &&
                  this.state.dragArraySale[i].visible == true
                ) {
                  fixedColCountSale = fixedColCountSale + 1;
                }
                this.setState({ fixedColumnsCountSale: fixedColCountSale + 1 });
              }
            }
          );
        });
    }
  }

  showDerivedColumns() {
    if (this.state.showDerivedCols === true) {
      this.setState({
        showDerivedCols: false,
      });
    } else {
      this.setState({
        showDerivedCols: true,
      });
    }

    var columns = [];

    var visibleColumns = this.state.dragArray.filter(function (obj) {
      return obj.visible === true;
    });
    var columns = visibleColumns.map((elem) => elem.name);
    columns.unshift("Select");
    var _columns = [];

    for (let index = 0; index < columns.length; index++) {
      _columns.push({
        i: index,
        cellRenderer: ({
          columnIndex,
          column,
          rowData,
          rowIndex,
          className,
        }) => {
          var derived = [];

          try {
            derived = JSON.parse(rowData.derived_columns);
          } catch (e) {
            derived = [];
          }

          if (
            this.state.showDerivedCols == true &&
            derived.indexOf(columns[index]) > -1
          ) {
            return (
              <td
                className={className}
                style={{ background: "#ff9515", color: "#FFF" }}
              >
                {rowData[columns[index]]}
              </td>
            );
          } else {
            if (columns[index] == "Download" && rowData["Download"] === 1) {
              return (
                <td
                  className={className}
                  onClick={(e) => {
                    this.downloadRowData(rowData["CRE ID"]);
                  }}
                >
                  {<FontAwesomeIcon icon={faArrowDown} />}
                </td>
              );
            } else if (
              columns[index] == "Download" &&
              rowData["Download"] === 0
            ) {
              return <td className={className}>{"-"}</td>;
              // return (
              //   <td
              //     className={className}
              //     onClick={(e) => {
              //       this.downloadRowData(rowData["CRE ID"]);
              //     }}
              //   >
              //     {<FontAwesomeIcon icon={faArrowDown} />}
              //   </td>
              // );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 1
            ) {
              return (
                <td className={className}>
                  {
                    <Link
                      to="#"
                      onClick={(e) => {
                        this.openModalDoc(rowData["CRE ID"]);
                      }}
                    >
                      View
                    </Link>
                  }
                </td>
              );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 0
            ) {
              // return (
              //   <td className={className}>
              //     {
              //       <Link
              //         to="#"
              //         onClick={(e) => {
              //           this.openModalDoc(rowData["CRE ID"]);
              //         }}
              //       >
              //         View
              //       </Link>
              //     }
              //   </td>
              // );
              return <td className={className}>{"-"}</td>;
            } else {
              return (
                <td className={className} title={rowData[columns[index]]}>
                  {this.linkingUrl(columns[index], rowData[columns[index]])}
                </td>
              );
            }
          }
        },
        headerRenderer: ({ columnIndex, column, className }) => {
          if (columns[index] == "Select") {
            return (
              <th className={className}>
                View
                <p>{this.state.headerUnits[columns[index]]}</p>
              </th>
            );
          } else {
            return (
              <th className={className}>
                {/* {columns[index]}
                <p>{this.state.headerUnits[columns[index]]}</p> */}
                {this.headerView(
                  columns[index],
                  this.state.headerUnits[columns[index]]
                )}
              </th>
            );
          }
        },
        footerRenderer: ({ columnIndex, column, className }) => {
          if (this.state.averages[columns[index]] != undefined) {
            return (
              <td className={className}>
                {this.state.averages[columns[index]].avg}
              </td>
            );
          } else {
            return <td></td>;
          }
        },

        width: 100,
      });
    }
    this.setState({
      columns: _columns,
    });
    if (this.state.showDerivedCols === true) {
      this.setState({
        showDerivedCols: false,
      });
    } else {
      this.setState({
        showDerivedCols: true,
      });
    }
    // if (this.state.showDerivedCols === true) {
    //   this.setState({
    //     dropdownTxt: "Hide Derived Data",
    //   });
    // } else {
    //   this.setState({
    //     dropdownTxt: "Show Derived Data",
    //   });
    // }
  }

  showDerivedColumnsSale() {
    if (this.state.showDerivedColsSale === true) {
      this.setState({
        showDerivedColsSale: false,
      });
    } else {
      this.setState({
        showDerivedColsSale: true,
      });
    }

    var columns = [];

    var visibleColumns = this.state.dragArraySale.filter(function (obj) {
      return obj.visible === true;
    });
    var columns = visibleColumns.map((elem) => elem.name);
    columns.unshift("Select");
    var _columns = [];

    for (let index = 0; index < columns.length; index++) {
      _columns.push({
        i: index,
        cellRenderer: ({
          columnIndex,
          column,
          rowData,
          rowIndex,
          className,
        }) => {
          var derived = [];

          try {
            derived = JSON.parse(rowData.derived_columns);
          } catch (e) {
            derived = [];
          }

          if (
            this.state.showDerivedColsSale == true &&
            derived.indexOf(columns[index]) > -1
          ) {
            return (
              <td
                className={className}
                style={{ background: "#ff9515", color: "#FFF" }}
              >
                {rowData[columns[index]]}
              </td>
            );
          } else {
            if (columns[index] == "Download" && rowData["Download"] === 1) {
              return (
                <td
                  className={className}
                  onClick={(e) => {
                    this.downloadRowDataSale(rowData["CRE ID"]);
                  }}
                >
                  {<FontAwesomeIcon icon={faArrowDown} />}
                </td>
              );
            } else if (
              columns[index] == "Download" &&
              rowData["Download"] === 0
            ) {
              return <td className={className}>{"-"}</td>;
              // return (
              //   <td
              //     className={className}
              //     onClick={(e) => {
              //       this.downloadRowData(rowData["CRE ID"]);
              //     }}
              //   >
              //     {<FontAwesomeIcon icon={faArrowDown} />}
              //   </td>
              // );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 1
            ) {
              return (
                <td className={className}>
                  {
                    <Link
                      to="#"
                      onClick={(e) => {
                        this.openModalDoc(rowData["CRE ID"]);
                      }}
                    >
                      View
                    </Link>
                  }
                </td>
              );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 0
            ) {
              // return (
              //   <td className={className}>
              //     {
              //       <Link
              //         to="#"
              //         onClick={(e) => {
              //           this.openModalDoc(rowData["CRE ID"]);
              //         }}
              //       >
              //         View
              //       </Link>
              //     }
              //   </td>
              // );
              return <td className={className}>{"-"}</td>;
            } else {
              return (
                <td className={className} title={rowData[columns[index]]}>
                  {this.linkingUrl(columns[index], rowData[columns[index]])}
                </td>
              );
            }
          }
        },
        headerRenderer: ({ columnIndex, column, className }) => {
          if (columns[index] == "Select") {
            return (
              <th className={className}>
                View
                <p>{this.state.headerUnitsSale[columns[index]]}</p>
              </th>
            );
          } else {
            return (
              <th className={className}>
                {/* {columns[index]}
                <p>{this.state.headerUnits[columns[index]]}</p> */}
                {this.headerView(
                  columns[index],
                  this.state.headerUnitsSale[columns[index]]
                )}
              </th>
            );
          }
        },
        footerRenderer: ({ columnIndex, column, className }) => {
          if (this.state.averagesSale[columns[index]] != undefined) {
            return (
              <td className={className}>
                {this.state.averagesSale[columns[index]].avg}
              </td>
            );
          } else {
            return <td></td>;
          }
        },

        width: 100,
      });
    }
    this.setState({
      columnsSale: _columns,
    });
    if (this.state.showDerivedColsSale === true) {
      this.setState({
        showDerivedColsSale: false,
      });
    } else {
      this.setState({
        showDerivedColsSale: true,
      });
    }
    // if (this.state.showDerivedCols === true) {
    //   this.setState({
    //     dropdownTxt: "Hide Derived Data",
    //   });
    // } else {
    //   this.setState({
    //     dropdownTxt: "Show Derived Data",
    //   });
    // }
  }

  componentWillUnmount() {
    clearTimeout(this._loadRowsTimeout);
  }

  onFillTableWidth = (fillTableWidth) => {
    this.setState({
      fillTableWidth: fillTableWidth,
    });
  };

  onFillTableWidthSale = (fillTableWidth) => {
    this.setState({
      fillTableWidthSale: fillTableWidth,
    });
  };

  onInfiniteScrolling = (infiniteScrolling) => {
    clearTimeout(this._loadRowsTimeout);

    this.setState({
      noRows: false,
      infiniteScrolling,
      // rows: rows,
      isInfiniteLoading: false,
    });
  };

  onInfiniteScrollingSale = (infiniteScrolling) => {
    clearTimeout(this._loadRowsTimeout);

    this.setState({
      noRowsSale: false,
      infiniteScrolling,
      // rows: rows,
      isInfiniteLoadingSale: false,
    });
  };

  onInfiniteLoad = () => {
    console.log("Loading new rows!");
    const rows = this.state.rows;
    this.state.page = this.state.page + 1;
    this.setState({
      isInfiniteLoading: true,
    });
    apiMiddleware
      .post(
        "api/edge/office/get_lease_transactions",
        BodyAsFormDataWithSort(
          this.state.page,
          this.state.futureRentDate,
          JSON.stringify(this.state.filters),
          this.state.sortBy,
          this.state.sortOrder
        )
      )
      .then((res) => {
        for (let index = 0; index < res.data.rows.length; index++) {
          rows.push(res.data.rows[index]);
        }
        this.setState({
          transactionData: res.data,
          rows: rows,
          isInfiniteLoading: false,
        });
      });
  };

  onInfiniteLoadSale = () => {
    const rows = this.state.rowsSale;
    this.state.pageSale = this.state.pageSale + 1;
    this.setState({
      isInfiniteLoadingSale: true,
    });
    apiMiddleware
      .post(
        "api/edge/office/get_sales_transactions",
        BodyAsFormDataWithSort(
          this.state.pageSale,
          this.state.futureRentDateSale,
          JSON.stringify(this.state.filters),
          this.state.sortBySale,
          this.state.sortOrderSale
        )
      )
      .then((res) => {
        for (let index = 0; index < res.data.rows.length; index++) {
          rows.push(res.data.rows[index]);
        }
        this.setState({
          transactionDataSale: res.data,
          rowsSale: rows,
          isInfiniteLoadingSale: false,
        });
      });
  };

  onFixedColumnsCountChange = (fixedColumnsCount) => {
    this.setState({
      fixedColumnsCount: fixedColumnsCount,
    });
  };

  onFixedColumnsCountChangeSale = (fixedColumnsCount) => {
    this.setState({
      fixedColumnsCountSale: fixedColumnsCount,
    });
  };

  onColumnWidthChange = (columnIndex, width) => {
    const newColumns = [...this.state.columns];
    newColumns[columnIndex] = {
      ...newColumns[columnIndex],
      width: width,
    };
    this.setState({
      columns: newColumns,
    });
  };

  onColumnWidthChangeSale = (columnIndex, width) => {
    const newColumns = [...this.state.columnsSale];
    newColumns[columnIndex] = {
      ...newColumns[columnIndex],
      width: width,
    };
    this.setState({
      columnsSale: newColumns,
    });
  };

  onSelectionChange = (selectedRows) => {
    console.log("selectedRows");
    this.setState({
      selectedRows: selectedRows,
    });
  };

  onSelectionChangeSale = (selectedRows) => {
    console.log(selectedRows);
    this.setState({
      selectedRowsSale: selectedRows,
    });
  };

  setCanSelectMultipleRows = (canSelectMultipleRows) => {
    this.setState({
      canSelectMultipleRows: canSelectMultipleRows,
    });
  };

  setCanSelectMultipleRowsSale = (canSelectMultipleRows) => {
    this.setState({
      canSelectMultipleRowsSale: canSelectMultipleRows,
    });
  };

  handleOnDragEnd = (e) => {
    if (!e.destination) return;
    const items = Array.from(this.state.dragArray);
    const [reorderedItem] = items.splice(e.source.index, 1);
    items.splice(e.destination.index, 0, reorderedItem);
    this.setState({ dragArray: items });
    if (e.source.index > e.destination.index) {
      this.state.dragArray[e.source.index].visible = [
        this.state.dragArray[e.destination.index].length - 1,
      ].visible;
      this.state.dragArray[e.source.index].static = [
        this.state.dragArray[e.destination.index].length - 1,
      ].static;
      this.setState({});
    } else {
      this.state.dragArray[e.source.index].visible = [
        this.state.dragArray[e.destination.index].length + 1,
      ].visible;
      this.state.dragArray[e.source.index].static = [
        this.state.dragArray[e.destination.index].length + 1,
      ].static;
      this.setState({});
    }
  };

  handleOnDragEndSale = (e) => {
    if (!e.destination) return;
    const items = Array.from(this.state.dragArraySale);
    const [reorderedItem] = items.splice(e.source.index, 1);
    items.splice(e.destination.index, 0, reorderedItem);
    this.setState({ dragArraySale: items });
    if (e.source.index > e.destination.index) {
      this.state.dragArraySale[e.source.index].visible = [
        this.state.dragArraySale[e.destination.index].length - 1,
      ].visible;
      this.state.dragArraySale[e.source.index].static = [
        this.state.dragArraySale[e.destination.index].length - 1,
      ].static;
      this.setState({});
    } else {
      this.state.dragArraySale[e.source.index].visible = [
        this.state.dragArraySale[e.destination.index].length + 1,
      ].visible;
      this.state.dragArraySale[e.source.index].static = [
        this.state.dragArraySale[e.destination.index].length + 1,
      ].static;
      this.setState({});
    }
  };

  openModal = () => {
    this.setState({ dragArray: this.state.currentArray }, () => {});
    this.setState({ isOpen: true });
  };
  closeModal = () => this.setState({ isOpen: false });

  openModalSale = () => {
    this.setState({ dragArraySale: this.state.currentArraySale }, () => {});
    this.setState({ isOpenSale: true });
  };

  closeModalSale = () => this.setState({ isOpenSale: false });
  openTimeModal = () => {
    this.setState({ isOpenTimeModal: true });
  };

  closeTimeModal = () => this.setState({ isOpenTimeModal: false });

  openTimeModalSale = () => {
    this.setState({ isOpenTimeModalSale: true });
  };

  closeTimeModalSale = () => this.setState({ isOpenTimeModalSale: false });

  openNotesModal = () => {
    this.setState({ isOpenNotesModal: true });
  };

  closeNotesModal = () => this.setState({ isOpenNotesModal: false });

  openModalColumn = () => {
    if (this.props.downloadOption.edge_office_export === 0) {
      this.setState({ isOpenErrorDisplayModal: true });
    } else {
      this.setState({ isOpenColumnsModal: true });
    }
  };

  closeErrorDisplayModal = () => {
    this.setState({ isOpenErrorDisplayModal: false });
  };

  openModalColumnSale = () => {
    if (this.props.downloadOption.edge_office_export === 0) {
      this.setState({ isOpenErrorDisplayModalSale: true });
    } else {
      this.setState({ isOpenColumnsModalSale: true });
    }
  };

  closeErrorDisplayModalSale = () => {
    this.setState({ isOpenErrorDisplayModalSale: false });
  };

  closeModalColumn = () => this.setState({ isOpenColumnsModal: false });

  closeModalColumnSale = () => this.setState({ isOpenColumnsModalSale: false });

  openModalExcel = () => {
    if (this.props.downloadOption.edge_office_export === 0) {
      this.setState({ isOpenErrorDisplayModal: true });
    } else {
      this.setState({ isOpenExcelModal: true });
    }
  };

  closeModalExcel = () => this.setState({ isOpenExcelModal: false });

  openModalExcelSale = () => {
    if (this.props.downloadOption.edge_office_export === 0) {
      this.setState({ isOpenErrorDisplayModalSale: true });
    } else {
      this.setState({ isOpenExcelModalSale: true });
    }
  };

  closeModalExcelSale = () => this.setState({ isOpenExcelModalSale: false });

  openModalPng = () => {
    if (this.props.downloadOption.edge_office_export_pdf === 0) {
      this.setState({ isOpenErrorDisplayModal: true });
    } else {
      if (Object.keys(this.state.selectedRows).length == 0) {
        alert("Select atleast 1 row before exporting as PNG.");
      } else {
        this.setState({ isOpenPngModal: true });
      }
    }
  };

  closeModalPng = () => this.setState({ isOpenPngModal: false });

  openModalPngSale = () => {
    if (this.props.downloadOption.edge_office_export_pdf === 0) {
      this.setState({ isOpenErrorDisplayModalSale: true });
    } else {
      if (Object.keys(this.state.selectedRowsSale).length == 0) {
        alert("Select atleast 1 row before exporting as PNG.");
      } else {
        this.setState({ isOpenPngModalSale: true });
      }
    }
  };

  closeModalPngSale = () => this.setState({ isOpenPngModalSale: false });

  openModalDownload = () => {
    this.setState({ isOpenDownloadModal: true });
  };

  closeModalDownload = () => this.setState({ isOpenDownloadModal: false });

  openModalDownloadSale = () => {
    this.setState({ isOpenDownloadModalSale: true });
  };

  closeModalDownloadSale = () =>
    this.setState({ isOpenDownloadModalSale: false });

  openModalDoc = (id) => {
    id = id.split("-").pop();
    this.setState({ creIdDoc: id }, () => {
      apiMiddleware
        .post(
          "api/screener/view-document",
          BodyAsFormData4(this.state.creIdDoc)
        )
        .then((res) => {
          this.setState(
            { isOpenDocModal: true, docUrl: res.data.request },
            () => {}
          );
        });
    });
  };

  closeModalDoc = () => this.setState({ isOpenDocModal: false });

  makeColumnVisible(e) {
    let _drag = this.state.dragArray;
    if (_drag[e].visible == false) {
      _drag[e].visible = true;
    } else {
      _drag[e].visible = false;
    }
    this.setState({ dragArray: _drag });
  }

  makeColumnVisibleSale(e) {
    let _drag = this.state.dragArraySale;
    if (_drag[e].visible == false) {
      _drag[e].visible = true;
    } else {
      _drag[e].visible = false;
    }
    this.setState({ dragArraySale: _drag });
  }

  makeColumnStatic(index) {
    let _drag = this.state.dragArray;
    if (_drag[index].static == false) {
      var staticColumns = _drag.slice(0, _drag.indexOf(_drag[index + 1]));
      console.log(staticColumns);
      _drag.forEach((item1) => {
        var itemFromArr2 = staticColumns.find(
          (item2) => item2.name == item1.name
        );
        if (itemFromArr2) {
          item1.static = true;
        }
      });
      this.setState({ dragArray: _drag });
    } else {
      var nonStaticColumns = _drag.slice(
        _drag.indexOf(_drag[index + 1]),
        _drag.length
      );
      _drag.forEach((item1) => {
        var itemFromArr2 = nonStaticColumns.find(
          (item2) => item2.name == item1.name
        );
        if (itemFromArr2) {
          item1.static = false;
        }
      });
      this.setState({ dragArray: _drag });
    }
  }

  makeColumnStaticSale(index) {
    let _drag = this.state.dragArraySale;
    if (_drag[index].static == false) {
      var staticColumns = _drag.slice(0, _drag.indexOf(_drag[index + 1]));
      _drag.forEach((item1) => {
        var itemFromArr2 = staticColumns.find(
          (item2) => item2.name == item1.name
        );
        if (itemFromArr2) {
          item1.static = true;
        }
      });
      this.setState({ dragArraySale: _drag });
    } else {
      var nonStaticColumns = _drag.slice(
        _drag.indexOf(_drag[index + 1]),
        _drag.length
      );
      _drag.forEach((item1) => {
        var itemFromArr2 = nonStaticColumns.find(
          (item2) => item2.name == item1.name
        );
        if (itemFromArr2) {
          item1.static = false;
        }
      });
      this.setState({ dragArraySale: _drag });
    }
  }

  saveColumnPref() {
    this.setState({ currentArray: this.state.dragArray }, () => {});
    this.closeModal();
    var visibleColumns = this.state.dragArray.filter(function (obj) {
      return obj.visible === true;
    });

    var columns = visibleColumns.map((elem) => elem.name);
    columns.unshift("Select");

    var _columns = [];
    for (let index = 0; index < columns.length; index++) {
      _columns.push({
        i: index,
        cellRenderer: ({
          columnIndex,
          column,
          rowData,
          rowIndex,
          className,
        }) => {
          var derived = [];

          try {
            derived = JSON.parse(rowData.derived_columns);
          } catch (e) {
            derived = [];
          }

          if (
            this.state.showDerivedCols == true &&
            derived.indexOf(columns[index]) > -1
          ) {
            return (
              <td
                className={className}
                style={{ background: "#ff9515", color: "#FFF" }}
              >
                {rowData[columns[index]]}
              </td>
            );
          } else {
            if (columns[index] == "Download" && rowData["Download"] === 1) {
              return (
                <td
                  className={className}
                  onClick={(e) => {
                    this.downloadRowData(rowData["CRE ID"]);
                  }}
                >
                  {<FontAwesomeIcon icon={faArrowDown} />}
                </td>
              );
            } else if (
              columns[index] == "Download" &&
              rowData["Download"] === 0
            ) {
              return <td className={className}>{"-"}</td>;
              // return (
              //   <td
              //     className={className}
              //     onClick={(e) => {
              //       this.downloadRowData(rowData["CRE ID"]);
              //     }}
              //   >
              //     {<FontAwesomeIcon icon={faArrowDown} />}
              //   </td>
              // );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 1
            ) {
              return (
                <td className={className}>
                  {
                    <Link
                      to="#"
                      onClick={(e) => {
                        this.openModalDoc(rowData["CRE ID"]);
                      }}
                    >
                      View
                    </Link>
                  }
                </td>
              );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 0
            ) {
              // return (
              //   <td className={className}>
              //     {
              //       <Link
              //         to="#"
              //         onClick={(e) => {
              //           this.openModalDoc(rowData["CRE ID"]);
              //         }}
              //       >
              //         View
              //       </Link>
              //     }
              //   </td>
              // );
              return <td className={className}>{"-"}</td>;
            } else {
              return (
                <td className={className} title={rowData[columns[index]]}>
                  {this.linkingUrl(columns[index], rowData[columns[index]])}
                </td>
              );
            }
          }
        },
        headerRenderer: ({ columnIndex, column, className }) => {
          if (columns[index] == "Select") {
            return (
              <th className={className}>
                View
                <p>{this.state.headerUnits[columns[index]]}</p>
              </th>
            );
          } else {
            return (
              <th className={className}>
                {this.headerView(
                  columns[index],
                  this.state.headerUnits[columns[index]]
                )}
              </th>
            );
          }
        },
        footerRenderer: ({ columnIndex, column, className }) => {
          if (this.state.averages[columns[index]] != undefined) {
            return (
              <td className={className}>
                {this.state.averages[columns[index]].avg}
              </td>
            );
          } else {
            return <td></td>;
          }
        },

        width: 100,
      });
    }
    this.setState({
      columns: _columns,
    });
    this.setState({ rows: this.state.transactionData.rows });
    let fixedColCount = 0;
    for (let i = 0; i < this.state.dragArray.length; i++) {
      if (
        this.state.dragArray[i].static == true &&
        this.state.dragArray[i].visible == true
      ) {
        fixedColCount = fixedColCount + 1;
      }
      this.setState({ fixedColumnsCount: fixedColCount + 1 });
    }

    apiMiddleware.post(
      "api/edge/office/save_user_col_pref",
      BodyAsFormData1(JSON.stringify(this.state.currentArray))
    );
    // .then((res) => {
    //   this.setState({ majorRecentLeaseTransactions: res.data.splice(0, 5) });
    // });
  }

  saveColumnPrefSale() {
    this.setState({ currentArraySale: this.state.dragArraySale }, () => {});
    this.closeModal();
    var visibleColumns = this.state.dragArraySale.filter(function (obj) {
      return obj.visible === true;
    });

    var columns = visibleColumns.map((elem) => elem.name);
    columns.unshift("Select");

    var _columns = [];
    for (let index = 0; index < columns.length; index++) {
      _columns.push({
        i: index,
        cellRenderer: ({
          columnIndex,
          column,
          rowData,
          rowIndex,
          className,
        }) => {
          var derived = [];

          try {
            derived = JSON.parse(rowData.derived_columns);
          } catch (e) {
            derived = [];
          }

          if (
            this.state.showDerivedColsSale == true &&
            derived.indexOf(columns[index]) > -1
          ) {
            return (
              <td
                className={className}
                style={{ background: "#ff9515", color: "#FFF" }}
              >
                {rowData[columns[index]]}
              </td>
            );
          } else {
            if (columns[index] == "Download" && rowData["Download"] === 1) {
              return (
                <td
                  className={className}
                  onClick={(e) => {
                    this.downloadRowDataSale(rowData["CRE ID"]);
                  }}
                >
                  {<FontAwesomeIcon icon={faArrowDown} />}
                </td>
              );
            } else if (
              columns[index] == "Download" &&
              rowData["Download"] === 0
            ) {
              return <td className={className}>{"-"}</td>;
              // return (
              //   <td
              //     className={className}
              //     onClick={(e) => {
              //       this.downloadRowData(rowData["CRE ID"]);
              //     }}
              //   >
              //     {<FontAwesomeIcon icon={faArrowDown} />}
              //   </td>
              // );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 1
            ) {
              return (
                <td className={className}>
                  {
                    <Link
                      to="#"
                      onClick={(e) => {
                        this.openModalDoc(rowData["CRE ID"]);
                      }}
                    >
                      View
                    </Link>
                  }
                </td>
              );
            } else if (
              columns[index] == "View Document" &&
              rowData["View Document"] === 0
            ) {
              // return (
              //   <td className={className}>
              //     {
              //       <Link
              //         to="#"
              //         onClick={(e) => {
              //           this.openModalDoc(rowData["CRE ID"]);
              //         }}
              //       >
              //         View
              //       </Link>
              //     }
              //   </td>
              // );
              return <td className={className}>{"-"}</td>;
            } else {
              return (
                <td className={className} title={rowData[columns[index]]}>
                  {this.linkingUrl(columns[index], rowData[columns[index]])}
                </td>
              );
            }
          }
        },
        headerRenderer: ({ columnIndex, column, className }) => {
          if (columns[index] == "Select") {
            return (
              <th className={className}>
                View
                <p>{this.state.headerUnitsSale[columns[index]]}</p>
              </th>
            );
          } else {
            return (
              <th className={className}>
                {this.headerView(
                  columns[index],
                  this.state.headerUnitsSale[columns[index]]
                )}
              </th>
            );
          }
        },
        footerRenderer: ({ columnIndex, column, className }) => {
          if (this.state.averagesSale[columns[index]] != undefined) {
            return (
              <td className={className}>
                {this.state.averagesSale[columns[index]].avg}
              </td>
            );
          } else {
            return <td></td>;
          }
        },

        width: 100,
      });
    }
    this.setState({
      columnsSale: _columns,
    });
    this.setState({ rowsSale: this.state.transactionDataSale.rows });
    let fixedColCount = 0;
    for (let i = 0; i < this.state.dragArraySale.length; i++) {
      if (
        this.state.dragArraySale[i].static == true &&
        this.state.dragArraySale[i].visible == true
      ) {
        fixedColCount = fixedColCount + 1;
      }
      this.setState({ fixedColumnsCountSale: fixedColCount + 1 });
    }
    let body = new FormData();
    body.append("colPref", JSON.stringify(this.state.currentArraySale));
    body.append("screener", "edge_office_sales");
    apiMiddleware.post("api/edge/office/save_user_col_pref", body);
    // .then((res) => {
    //   this.setState({ majorRecentLeaseTransactions: res.data.splice(0, 5) });
    // });
  }

  downloadRowData(id) {
    id = id.split("-").pop();
    this.setState({ creId: id }, () => {
      apiMiddleware
        .post(
          "api/screener/download-document",
          BodyAsFormData4(this.state.creId)
        )
        .then((res) => {});
    });
  }

  downloadRowDataSale(id) {
    id = id.split("-").pop();
    this.setState({ creId: id }, () => {
      apiMiddleware
        .post(
          "api/screener/download-document",
          BodyAsFormData4(this.state.creId)
        )
        .then((res) => {});
    });
  }

  onDocumentLoadSuccess(numPages) {}

  getCsvCheckedVal(name) {
    if (this.state.checkedCsvCol.indexOf(name) > -1) {
      return true;
    } else {
      return false;
    }
  }

  getCsvCheckedValSale(name) {
    if (this.state.checkedCsvColSale.indexOf(name) > -1) {
      return true;
    } else {
      return false;
    }
  }

  getColumnVal(e) {
    let index = this.state.checkedCsvCol.indexOf(e.target.value);
    if (index > -1) {
      this.state.checkedCsvCol.splice(index, 1);
      this.setState({});
    } else {
      this.state.checkedCsvCol.push(e.target.value);
      this.setState({});
    }
  }

  getColumnValSale(e) {
    let index = this.state.checkedCsvColSale.indexOf(e.target.value);
    if (index > -1) {
      this.state.checkedCsvColSale.splice(index, 1);
      this.setState({});
    } else {
      this.state.checkedCsvColSale.push(e.target.value);
      this.setState({});
    }
  }

  exportCsv() {
    console.log(this.state.selectedRows);
    let selected = Object.keys(this.state.selectedRows);
    let selectedDataId = selected;
    let selectedCreId = selectedDataId.map((i) => "CREID-" + i);
    let count = Object.keys(this.state.selectedRows).length;
    let filter = JSON.stringify(this.state.filters);
    let derived;
    if (this.state.showDerivedCols === true) {
      derived = 1;
    } else {
      derived = 0;
    }
    let columnToExport = this.state.checkedCsvCol;
    let BodyAsFormData5 = (selected, filter, derived, cols) => {
      var body = new FormData();
      body.append("selected", JSON.stringify(selected));
      body.append("filter", filter);
      body.append("screener", "edge_office");
      body.append("derived", derived);
      for (let i = 0; i < columnToExport.length; i++) {
        body.append("column-to-export[]", columnToExport[i]);
      }
      return body;
    };
    apiMiddleware
      .post(
        "api/edge/office/export_csv",
        BodyAsFormData5(selected, filter, derived, columnToExport)
      )
      .then((res) => {
        if (res.error !== undefined && res.error.length > 0) {
          this.setState({
            isOpenErrorDisplayModal: true,
            errorMessage: res.error[0],
            isOpenColumnsModal: false,
          });
        } else {
          const response = {
            file: `${
              process.env.REACT_APP_API_DOMAIN + "/" + res.data.download_link
            }`,
          };
          window.open(response.file, "_blank");
          apiMiddleware
            .post(
              "api/user-activity/log-activity",
              logActivityBody(
                window.location.href.indexOf("=") === -1
                  ? ""
                  : "filters" + window.location.href.split("=").pop(),
                Object.keys(selectedCreId).length > 0
                  ? JSON.stringify(selectedCreId)
                  : "",
                count
              )
            )
            .then((res) => {
              console.log(res);
            });
        }
      });
  }

  exportCsvSale() {
    console.log(this.state.selectedRowsSale);
    let selected = Object.keys(this.state.selectedRowsSale);
    let selectedDataId = selected;
    let selectedCreId = selectedDataId.map((i) => "CREID-" + i);
    let count = Object.keys(this.state.selectedRowsSale).length;
    let filter = JSON.stringify(this.state.filters);
    let derived;
    if (this.state.showDerivedColsSale === true) {
      derived = 1;
    } else {
      derived = 0;
    }
    let columnToExport = this.state.checkedCsvColSale;
    let BodyAsFormData5 = (selected, filter, derived, cols) => {
      var body = new FormData();
      body.append("selected", JSON.stringify(selected));
      body.append("filter", filter);
      body.append("screener", "edge_office_sales");
      body.append("derived", derived);
      for (let i = 0; i < columnToExport.length; i++) {
        body.append("column-to-export[]", columnToExport[i]);
      }
      return body;
    };
    apiMiddleware
      .post(
        "api/edge/office/export_csv",
        BodyAsFormData5(selected, filter, derived, columnToExport)
      )
      .then((res) => {
        if (res.error !== undefined && res.error.length > 0) {
          console.log("pp");
          this.setState({
            isOpenErrorDisplayModalSale: true,
            errorMessage: res.error[0],
            isOpenColumnsModalSale: false,
          });
        } else {
          const response = {
            file: `${
              process.env.REACT_APP_API_DOMAIN + "/" + res.data.download_link
            }`,
          };
          window.open(response.file, "_blank");
          apiMiddleware
            .post(
              "api/user-activity/log-activity",
              logActivityBody(
                window.location.href.indexOf("=") === -1
                  ? ""
                  : "filters" + window.location.href.split("=").pop(),
                Object.keys(selectedCreId).length > 0
                  ? JSON.stringify(selectedCreId)
                  : "",
                count
              )
            )
            .then((res) => {
              console.log(res);
            });
        }
      });
  }

  exportExcel() {
    let selected = Object.keys(this.state.selectedRows);
    let filter = JSON.stringify(this.state.filters);
    let selectedDataId = selected;
    let selectedCreId = selectedDataId.map((i) => "CREID-" + i);
    let count = Object.keys(this.state.selectedRows).length;
    let derived;
    if (this.state.showDerivedCols === true) {
      derived = 1;
    } else {
      derived = 0;
    }
    let columnToExport = this.state.checkedCsvCol;
    let BodyAsFormData5 = (selected, filter, derived, cols) => {
      var body = new FormData();
      body.append("selected", JSON.stringify(selected));
      body.append("filter", filter);
      body.append("screener", "edge_office");
      body.append("derived", derived);
      for (let i = 0; i < columnToExport.length; i++) {
        body.append("column-to-export[]", columnToExport[i]);
      }
      return body;
    };

    apiMiddleware
      .post(
        "api/edge/office/export_excel",
        BodyAsFormData5(selected, filter, derived, columnToExport)
      )
      .then((res) => {
        if (res.error !== undefined && res.error.length > 0) {
          this.setState({
            isOpenColumnsModalSale: false,
            isOpenErrorDisplayModal: true,
            errorMessage: res.error[0],
          });
        } else {
          const response = {
            file: `${
              process.env.REACT_APP_API_DOMAIN + "/" + res.data.download_link
            }`,
          };
          window.open(response.file, "_blank");
          apiMiddleware
            .post(
              "api/user-activity/log-activity",
              logActivityBody(
                window.location.href.indexOf("=") === -1
                  ? ""
                  : "filters" + window.location.href.split("=").pop(),
                Object.keys(selectedCreId).length > 0
                  ? JSON.stringify(selectedCreId)
                  : "",
                count
              )
            )
            .then((res) => {
              console.log(res);
            });
        }
      });
  }

  toggleAll() {
    if (this.state.selectAll == true) {
      this.setState({ selectAll: false, checkedCsvCol: [] });
    } else {
      this.setState({ selectAll: true });
      let selectedCols = [];
      for (let i = 0; i < this.state.downloadColumns.length; i++) {
        selectedCols.push(this.state.downloadColumns[i].name);
      }
      this.setState({ checkedCsvCol: selectedCols });
    }
  }

  toggleAllSale() {
    if (this.state.selectAllSale == true) {
      this.setState({ selectAllSale: false, checkedCsvColSale: [] });
    } else {
      this.setState({ selectAllSale: true });
      let selectedColsSale = [];
      for (let i = 0; i < this.state.downloadColumnsSale.length; i++) {
        selectedColsSale.push(this.state.downloadColumnsSale[i].name);
      }
      this.setState({ checkedCsvColSale: selectedColsSale });
    }
  }

  downloadPng() {
    this.setState({ showImageLoader: true });
    let selected = Object.keys(this.state.selectedRows);
    let columnToExport = this.state.checkedCsvCol;
    let BodyAsFormData5 = (selected, cols) => {
      var body = new FormData();
      body.append("selected", JSON.stringify(selected));
      body.append("screener", "edge_office");
      for (let i = 0; i < columnToExport.length; i++) {
        body.append("column-to-export[]", columnToExport[i]);
      }
      return body;
    };
    apiMiddleware
      .post(
        "api/edge/office/export_table_as_pdf",
        BodyAsFormData5(selected, columnToExport)
      )
      .then((res) => {
        this.setState({ showImageLoader: false });
        let link = res.data;
        this.setState({ imgPath: link, isOpenPngModal: false }, () => {
          this.openModalDownload();
        });

        // const response = {
        //   file: `http://localhost:81/${res.data.download_link}`,
        // };
        // console.log(response);
        // window.open(response.file, "_blank");
      });
  }

  downloadPngSale() {
    this.setState({ showImageLoader: true });
    let selected = Object.keys(this.state.selectedRowsSale);
    let columnToExport = this.state.checkedCsvColSale;
    let BodyAsFormData5 = (selected, cols) => {
      var body = new FormData();
      body.append("selected", JSON.stringify(selected));
      body.append("screener", "edge_office_sales");
      for (let i = 0; i < columnToExport.length; i++) {
        body.append("column-to-export[]", columnToExport[i]);
      }
      return body;
    };
    apiMiddleware
      .post(
        "api/edge/office/export_table_as_pdf",
        BodyAsFormData5(selected, columnToExport)
      )
      .then((res) => {
        if (res.error !== undefined && res.error.length > 0) {
          console.log("pp");
          this.setState({
            isOpenErrorDisplayModalSale: true,
            errorMessage: res.error[0],
            isOpenPngModalSale: false,
          });
        } else {
          this.setState({ showImageLoader: false });
          let link = res.data;
          this.setState({ imgPath: link, isOpenPngModalSale: false }, () => {
            this.openModalDownload();
          });
        }

        // const response = {
        //   file: `http://localhost:81/${res.data.download_link}`,
        // };
        // console.log(response);
        // window.open(response.file, "_blank");
      });
  }

  downloadPngImg = () => {
    saveAs(this.state.imgPath, "image.png");
  };

  downloadPngImgSale = () => {
    saveAs(this.state.imgPathSale, "image.png");
  };

  setDate(date) {
    this.setState({ startDate: date });
    let futureDate = date;
    futureDate = futureDate.toISOString().split("T")[0];
    this.setState({ futureRentDate: futureDate }, () => {
      var filters;
      if (JSON.stringify(this.props.filters) == "{}") {
        filters = JSON.stringify(this.context.filters);
      } else {
        filters = JSON.stringify(this.props.filters);
      }
      this.state.filters = filters;
      apiMiddleware
        .post(
          "api/edge/office/get_lease_transactions",
          BodyAsFormDataWithSort(
            this.state.page,
            this.state.futureRentDate,
            JSON.stringify(this.state.filters),
            this.state.sortBy,
            this.state.sortOrder
          )
        )
        .then((res) => {
          this.closeTimeModal();
          this.setState({
            averages: res.data.averages,
            headerUnits: res.data.columns.unit,
          });
          var columns = [];

          var visibleColumns = this.state.dragArray.filter(function (obj) {
            return obj.visible === true;
          });
          var columns = visibleColumns.map((elem) => elem.name);
          columns.unshift("Select");
          var _columns = [];

          for (let index = 0; index < columns.length; index++) {
            _columns.push({
              i: index,
              cellRenderer: ({
                columnIndex,
                column,
                rowData,
                rowIndex,
                className,
              }) => {
                var derived = [];
                try {
                  derived = JSON.parse(rowData.derived_columns);
                } catch (e) {
                  derived = [];
                }
                if (
                  this.state.showDerivedCols == true &&
                  derived.indexOf(columns[index]) > -1
                ) {
                  return (
                    <td
                      className={className}
                      style={{ background: "#ff9515", color: "#FFF" }}
                    >
                      {rowData[columns[index]]}
                    </td>
                  );
                } else {
                  if (
                    columns[index] == "Download" &&
                    rowData["Download"] === 1
                  ) {
                    return (
                      <td
                        className={className}
                        onClick={(e) => {
                          this.downloadRowData(rowData["CRE ID"]);
                        }}
                      >
                        {<FontAwesomeIcon icon={faArrowDown} />}
                      </td>
                    );
                  } else if (
                    columns[index] == "Download" &&
                    rowData["Download"] === 0
                  ) {
                    return <td className={className}>{"-"}</td>;
                  } else if (
                    columns[index] == "View Document" &&
                    rowData["View Document"] === 1
                  ) {
                    return (
                      <td className={className}>
                        {
                          <Link
                            to="#"
                            onClick={(e) => {
                              this.openModalDoc(rowData["CRE ID"]);
                            }}
                          >
                            View
                          </Link>
                        }
                      </td>
                    );
                  } else if (
                    columns[index] == "View Document" &&
                    rowData["View Document"] === 0
                  ) {
                    return <td className={className}>{"-"}</td>;
                  } else {
                    return (
                      <td className={className} title={rowData[columns[index]]}>
                        {this.linkingUrl(
                          columns[index],
                          rowData[columns[index]]
                        )}
                      </td>
                    );
                  }
                }
              },
              headerRenderer: ({ columnIndex, column, className }) => {
                if (columns[index] == "Select") {
                  return (
                    <th className={className}>
                      View
                      <p>{this.state.headerUnits[columns[index]]}</p>
                    </th>
                  );
                } else {
                  return (
                    <th className={className}>
                      {this.headerView(
                        columns[index],
                        this.state.headerUnits[columns[index]]
                      )}
                    </th>
                  );
                }
              },
              footerRenderer: ({ columnIndex, column, className }) => {
                if (this.state.averages[columns[index]] != undefined) {
                  return (
                    <td className={className}>
                      {this.state.averages[columns[index]].avg}
                    </td>
                  );
                } else {
                  return <td></td>;
                }
              },

              width: 100,
            });
          }
          this.setState({
            columns: _columns,
          });
          this.setState({ rows: res.data.rows });
          this.setState({ transactionData: res.data });
        });
      let fixedColCount = 0;
      for (let i = 0; i < this.state.dragArray.length; i++) {
        if (
          this.state.dragArray[i].static == true &&
          this.state.dragArray[i].visible == true
        ) {
          fixedColCount = fixedColCount + 1;
        }
        this.setState({ fixedColumnsCount: fixedColCount + 1 });
      }
    });
  }

  setDateSale(date) {
    this.setState({ startDateSale: date });
    let futureDate = date;
    futureDate = futureDate.toISOString().split("T")[0];
    this.setState({ futureRentDateSale: futureDate }, () => {
      var filters;
      if (JSON.stringify(this.props.filters) == "{}") {
        filters = JSON.stringify(this.context.filters);
      } else {
        filters = JSON.stringify(this.props.filters);
      }
      this.state.filters = filters;
      apiMiddleware
        .post(
          "api/edge/office/get_sales_transactions",
          BodyAsFormDataWithSort(
            this.state.pageSale,
            this.state.futureRentDateSale,
            JSON.stringify(this.state.filters),
            this.state.sortBySale,
            this.state.sortOrderSale
          )
        )
        .then((res) => {
          this.closeTimeModal();
          this.setState({
            averagesSale: res.data.averages,
            headerUnitsSale: res.data.columns.unit,
          });
          var columns = [];

          var visibleColumns = this.state.dragArraySale.filter(function (obj) {
            return obj.visible === true;
          });
          var columns = visibleColumns.map((elem) => elem.name);
          columns.unshift("Select");
          var _columns = [];

          for (let index = 0; index < columns.length; index++) {
            _columns.push({
              i: index,
              cellRenderer: ({
                columnIndex,
                column,
                rowData,
                rowIndex,
                className,
              }) => {
                var derived = [];
                try {
                  derived = JSON.parse(rowData.derived_columns);
                } catch (e) {
                  derived = [];
                }
                if (
                  this.state.showDerivedColsSale == true &&
                  derived.indexOf(columns[index]) > -1
                ) {
                  return (
                    <td
                      className={className}
                      style={{ background: "#ff9515", color: "#FFF" }}
                    >
                      {rowData[columns[index]]}
                    </td>
                  );
                } else {
                  if (
                    columns[index] == "Download" &&
                    rowData["Download"] === 1
                  ) {
                    return (
                      <td
                        className={className}
                        onClick={(e) => {
                          this.downloadRowDataSale(rowData["CRE ID"]);
                        }}
                      >
                        {<FontAwesomeIcon icon={faArrowDown} />}
                      </td>
                    );
                  } else if (
                    columns[index] == "Download" &&
                    rowData["Download"] === 0
                  ) {
                    return <td className={className}>{"-"}</td>;
                  } else if (
                    columns[index] == "View Document" &&
                    rowData["View Document"] === 1
                  ) {
                    return (
                      <td className={className}>
                        {
                          <Link
                            to="#"
                            onClick={(e) => {
                              this.openModalDoc(rowData["CRE ID"]);
                            }}
                          >
                            View
                          </Link>
                        }
                      </td>
                    );
                  } else if (
                    columns[index] == "View Document" &&
                    rowData["View Document"] === 0
                  ) {
                    return <td className={className}>{"-"}</td>;
                  } else {
                    return (
                      <td className={className} title={rowData[columns[index]]}>
                        {this.linkingUrl(
                          columns[index],
                          rowData[columns[index]]
                        )}
                      </td>
                    );
                  }
                }
              },
              headerRenderer: ({ columnIndex, column, className }) => {
                if (columns[index] == "Select") {
                  return (
                    <th className={className}>
                      View
                      <p>{this.state.headerUnitsSale[columns[index]]}</p>
                    </th>
                  );
                } else {
                  return (
                    <th className={className}>
                      {this.headerView(
                        columns[index],
                        this.state.headerUnitsSale[columns[index]]
                      )}
                    </th>
                  );
                }
              },
              footerRenderer: ({ columnIndex, column, className }) => {
                if (this.state.averagesSale[columns[index]] != undefined) {
                  return (
                    <td className={className}>
                      {this.state.averagesSale[columns[index]].avg}
                    </td>
                  );
                } else {
                  return <td></td>;
                }
              },

              width: 100,
            });
          }
          this.setState({
            columnsSale: _columns,
          });
          this.setState({ rowsSale: res.data.rows });
          this.setState({ transactionDataSale: res.data });
        });
      let fixedColCount = 0;
      for (let i = 0; i < this.state.dragArraySale.length; i++) {
        if (
          this.state.dragArraySale[i].static == true &&
          this.state.dragArraySale[i].visible == true
        ) {
          fixedColCount = fixedColCount + 1;
        }
        this.setState({ fixedColumnsCountSale: fixedColCount + 1 });
      }
    });
  }

  render() {
    const {
      numberOfColumns,
      noRows,
      rowIdKey,
      fixedColumnsCount,
      fillTableWidth,
      infiniteScrolling,
      displayBottomUpwards,
      rows,
      columns,
      selectedRows,
      canSelectMultipleRows,
      fixedColumnsCountSale,
      fillTableWidthSale,
      infiniteScrollingSale,
      displayBottomUpwardsSale,
      rowsSale,
      columnsSale,
      selectedRowsSale,
    } = this.state;

    return (
      <div className="container-fluid developer mapsPage transactionsPage customPage p-0">
        <div className="row">
          <div className="col-lg-12">
            <div className="widget widgetTable">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Lease Summary</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <FontAwesomeIcon icon={faArrowDown} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={this.openModalColumn}>
                        Download as CSV
                      </Dropdown.Item>
                      <Dropdown.Item onClick={this.openModalExcel}>
                        Download as Excel
                      </Dropdown.Item>
                      <Dropdown.Item onClick={this.openModalPng}>
                        Download as PNG
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <p
                    className="colorBlack downloads"
                    style={{ fontSize: "1rem" }}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                    <ul className="downloadOptions" style={{ zIndex: "999" }}>
                      <li className="excelDownload" onClick={this.openModal}>
                        Manage Columns
                      </li>
                      <li
                        className="pdfDownload"
                        onClick={(e) => {
                          this.showDerivedColumns();
                        }}
                      >
                        {this.state.showDerivedCols == true
                          ? this.state.dropdownTxt
                          : "Show Derived Data"}
                      </li>
                      <li
                        className="excelDownload"
                        onClick={(e) => {
                          this.openNotesModal();
                        }}
                      >
                        Notes
                      </li>
                      <li
                        className="excelDownload"
                        onClick={(e) => {
                          this.openTimeModal();
                        }}
                      >
                        Time Machine
                      </li>
                    </ul>
                  </p>
                </div>
                <Table
                  className="example-table"
                  tableClassName="table table-bordered table-striped"
                  height={500}
                  rowHeight={50}
                  rows={rows}
                  columns={columns}
                  fixedColumnsCount={fixedColumnsCount}
                  headerCount={1}
                  footerCount={1}
                  fixBorders
                  fillTableWidth={fillTableWidth}
                  noRowsRenderer={() => "No Data Found"}
                  rowIdKey="Select"
                  selectedRows={selectedRows}
                  onSelectionChange={this.onSelectionChange}
                  canSelectMultipleRows={true}
                  infiniteLoadBeginEdgeOffset={
                    infiniteScrolling ? 150 : undefined
                  }
                  isInfiniteLoading={
                    infiniteScrolling ? this.state.isInfiniteLoading : undefined
                  }
                  onInfiniteLoad={
                    infiniteScrolling ? this.onInfiniteLoad : undefined
                  }
                  getLoadingSpinner={() => <div>Loading...</div>}
                  displayBottomUpwards={displayBottomUpwards}
                  onColumnWidthChange={this.onColumnWidthChange}
                  onColumnOrderChange={this.onColumnOrderChange}
                />
              </div>
            </div>
          </div>
          {/* {this.props.downloadOption.user_id == "1430" && ( */}
          <div className="col-lg-12 mt-4">
            <div className="widget widgetTable">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Sale Summary</p>
                </div>
                <div className="col-lg-3 text-end">
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <FontAwesomeIcon icon={faArrowDown} />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={this.openModalColumnSale}>
                        Download as CSV
                      </Dropdown.Item>
                      {/* <Dropdown.Item onClick={this.openModalExcelSale}>
                        Download as Excel
                      </Dropdown.Item> */}
                      <Dropdown.Item onClick={this.openModalPngSale}>
                        Download as PNG
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <p
                    className="colorBlack downloads"
                    style={{ fontSize: "1rem" }}
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                    <ul className="downloadOptions" style={{ zIndex: "999" }}>
                      <li
                        className="excelDownload"
                        onClick={this.openModalSale}
                      >
                        Manage Columns
                      </li>
                      <li
                        className="pdfDownload"
                        onClick={(e) => {
                          this.showDerivedColumnsSale();
                        }}
                      >
                        {this.state.showDerivedColsSale == true
                          ? this.state.dropdownTxtSale
                          : "Show Derived Data"}
                      </li>
                      <li
                        className="excelDownload"
                        onClick={(e) => {
                          this.openNotesModal();
                        }}
                      >
                        Notes
                      </li>
                      {/* <li
                        className="excelDownload"
                        onClick={(e) => {
                          this.openTimeModalSale();
                        }}
                      >
                        Time Machine
                      </li> */}
                    </ul>
                  </p>
                </div>
                <Table
                  className="example-table"
                  tableClassName="table table-bordered table-striped"
                  height={500}
                  rowHeight={50}
                  rows={rowsSale}
                  columns={columnsSale}
                  fixedColumnsCount={fixedColumnsCountSale}
                  headerCount={1}
                  footerCount={1}
                  fixBorders
                  fillTableWidth={fillTableWidthSale}
                  noRowsRenderer={() => "No Data Found"}
                  rowIdKey="Select"
                  selectedRows={selectedRowsSale}
                  onSelectionChange={this.onSelectionChangeSale}
                  canSelectMultipleRows={true}
                  infiniteLoadBeginEdgeOffset={
                    infiniteScrollingSale ? 150 : undefined
                  }
                  isInfiniteLoading={
                    infiniteScrollingSale
                      ? this.state.isInfiniteLoadingSale
                      : undefined
                  }
                  onInfiniteLoad={
                    infiniteScrollingSale ? this.onInfiniteLoadSale : undefined
                  }
                  getLoadingSpinner={() => <div>Loading...</div>}
                  displayBottomUpwards={displayBottomUpwardsSale}
                  onColumnWidthChange={this.onColumnWidthChangeSale}
                  onColumnOrderChange={this.onColumnOrderChangeSale}
                />
              </div>
            </div>
          </div>
          {/* )} */}

          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              className="columnsModal manageColumnsModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>Manage Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <DragDropContext onDragEnd={this.handleOnDragEnd}>
                  <Droppable droppableId="columnsUl">
                    {(provided) => (
                      <ul
                        className="columnsUl"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {this.state.dragArray.map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                          >
                            {(provided) => (
                              <li
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                                className={
                                  this.state.dragArray[i].visible == true &&
                                  this.state.dragArray[i].static == true
                                    ? "liActive"
                                    : "liInActive"
                                }
                              >
                                <p
                                  className={
                                    item.visible == true
                                      ? "visibleItem"
                                      : "invisibleItem"
                                  }
                                >
                                  {item.name}
                                </p>
                                <span
                                  className={
                                    item.static == true
                                      ? "columnStatic"
                                      : "columnNonStatic"
                                  }
                                  onClick={(e) => {
                                    this.makeColumnStatic(i);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faSnowflake} />
                                </span>
                                <span
                                  className={
                                    item.visible == true
                                      ? "columnVisible"
                                      : "columnInvisible"
                                  }
                                  onClick={(e) => {
                                    this.makeColumnVisible(i);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </span>
                              </li>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="default" className="resetDefault">
                  Reset to default
                </Button>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.saveColumnPrefSale();
                  }}
                >
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenSale}
              onHide={this.closeModalSale}
              className="columnsModal manageColumnsModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>Manage Columns Sale</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <DragDropContext onDragEnd={this.handleOnDragEndSale}>
                  <Droppable droppableId="columnsUl">
                    {(provided) => (
                      <ul
                        className="columnsUl"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {this.state.dragArraySale.map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                          >
                            {(provided) => (
                              <li
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                                className={
                                  this.state.dragArraySale[i].visible == true &&
                                  this.state.dragArraySale[i].static == true
                                    ? "liActive"
                                    : "liInActive"
                                }
                              >
                                <p
                                  className={
                                    item.visible == true
                                      ? "visibleItem"
                                      : "invisibleItem"
                                  }
                                >
                                  {item.name}
                                </p>
                                <span
                                  className={
                                    item.static == true
                                      ? "columnStatic"
                                      : "columnNonStatic"
                                  }
                                  onClick={(e) => {
                                    this.makeColumnStaticSale(i);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faSnowflake} />
                                </span>
                                <span
                                  className={
                                    item.visible == true
                                      ? "columnVisible"
                                      : "columnInvisible"
                                  }
                                  onClick={(e) => {
                                    this.makeColumnVisibleSale(i);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </span>
                              </li>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="default" className="resetDefault">
                  Reset to default
                </Button>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.saveColumnPrefSale();
                  }}
                >
                  Save
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenDocModal}
              onHide={this.closeModalDoc}
              className="columnsModal"
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Document</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Document
                  file={this.state.docUrl}
                  //onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  <Page pageNumber={this.state.pageNumber} />
                </Document>
              </Modal.Body>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenColumnsModal}
              onHide={this.closeModalColumn}
              className="columnsModal selectColumn"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 text-center mb-4">
                    <label>
                      <input
                        name={"selectAll"}
                        type="checkbox"
                        checked={this.state.selectAll}
                        className="me-2"
                        value={"select"}
                        onChange={(e) => {
                          this.toggleAll(e);
                        }}
                      />
                      Select/Deselect All
                    </label>
                  </div>
                </div>
                <ul className="selectColumns">
                  {this.state.downloadColumns.map((item, i) => (
                    <li>
                      <label>
                        <input
                          name={item.name}
                          type="checkbox"
                          checked={this.getCsvCheckedVal(item.name)}
                          className="me-2"
                          value={item.name}
                          onChange={(e) => {
                            this.getColumnVal(e);
                          }}
                        />
                        {item.name}
                      </label>
                    </li>
                  ))}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.exportCsv();
                  }}
                >
                  Export CSV
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenColumnsModalSale}
              onHide={this.closeModalColumnSale}
              className="columnsModal selectColumn"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 text-center mb-4">
                    <label>
                      <input
                        name={"selectAll"}
                        type="checkbox"
                        checked={this.state.selectAllSale}
                        className="me-2"
                        value={"select"}
                        onChange={(e) => {
                          this.toggleAllSale(e);
                        }}
                      />
                      Select/Deselect All
                    </label>
                  </div>
                </div>
                <ul className="selectColumns">
                  {this.state.downloadColumnsSale.map((item, i) => (
                    <li>
                      <label>
                        <input
                          name={item.name}
                          type="checkbox"
                          checked={this.getCsvCheckedValSale(item.name)}
                          className="me-2"
                          value={item.name}
                          onChange={(e) => {
                            this.getColumnValSale(e);
                          }}
                        />
                        {item.name}
                      </label>
                    </li>
                  ))}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.exportCsvSale();
                  }}
                >
                  Export CSV
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenExcelModal}
              onHide={this.closeModalExcel}
              className="columnsModal selectColumn"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 text-center mb-4">
                    <label>
                      <input
                        name={"selectAll"}
                        type="checkbox"
                        checked={this.state.selectAll}
                        className="me-2"
                        value={"select"}
                        onChange={(e) => {
                          this.toggleAll(e);
                        }}
                      />
                      Select/Deselect All
                    </label>
                  </div>
                </div>
                <ul className="selectColumns">
                  {this.state.downloadColumns.map((item, i) => (
                    <li>
                      <label>
                        <input
                          name={item.name}
                          type="checkbox"
                          checked={this.getCsvCheckedVal(item.name)}
                          className="me-2"
                          value={item.name}
                          onChange={(e) => {
                            this.getColumnVal(e);
                          }}
                        />
                        {item.name}
                      </label>
                    </li>
                  ))}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.exportExcel();
                  }}
                >
                  Export Excel
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenExcelModalSale}
              onHide={this.closeModalExcelSale}
              className="columnsModal selectColumn"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 text-center mb-4">
                    <label>
                      <input
                        name={"selectAll"}
                        type="checkbox"
                        checked={this.state.selectAllSale}
                        className="me-2"
                        value={"select"}
                        onChange={(e) => {
                          this.toggleAllSale(e);
                        }}
                      />
                      Select/Deselect All
                    </label>
                  </div>
                </div>
                <ul className="selectColumns">
                  {this.state.downloadColumnsSale.map((item, i) => (
                    <li>
                      <label>
                        <input
                          name={item.name}
                          type="checkbox"
                          checked={this.getCsvCheckedValSale(item.name)}
                          className="me-2"
                          value={item.name}
                          onChange={(e) => {
                            this.getColumnValSale(e);
                          }}
                        />
                        {item.name}
                      </label>
                    </li>
                  ))}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.exportExcelSale();
                  }}
                >
                  Export Excel
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenPngModal}
              onHide={this.closeModalPng}
              className="columnsModal selectColumn"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 text-center mb-4">
                    <label>
                      <input
                        name={"selectAll"}
                        type="checkbox"
                        checked={this.state.selectAll}
                        className="me-2"
                        value={"select"}
                        onChange={(e) => {
                          this.toggleAll(e);
                        }}
                      />
                      Select/Deselect All
                    </label>
                  </div>
                </div>
                <ul className="selectColumns">
                  {this.state.downloadColumns.map((item, i) => (
                    <li>
                      <label>
                        <input
                          name={item.name}
                          type="checkbox"
                          checked={this.getCsvCheckedVal(item.name)}
                          className="me-2"
                          value={item.name}
                          onChange={(e) => {
                            this.getColumnVal(e);
                          }}
                        />
                        {item.name}
                      </label>
                    </li>
                  ))}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.downloadPng();
                  }}
                >
                  Next
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenPngModalSale}
              onHide={this.closeModalPngSale}
              className="columnsModal selectColumn"
              size="md"
            >
              <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 text-center mb-4">
                    <label>
                      <input
                        name={"selectAll"}
                        type="checkbox"
                        checked={this.state.selectAllSale}
                        className="me-2"
                        value={"select"}
                        onChange={(e) => {
                          this.toggleAllSale(e);
                        }}
                      />
                      Select/Deselect All
                    </label>
                  </div>
                </div>
                <ul className="selectColumns">
                  {this.state.downloadColumnsSale.map((item, i) => (
                    <li>
                      <label>
                        <input
                          name={item.name}
                          type="checkbox"
                          checked={this.getCsvCheckedValSale(item.name)}
                          className="me-2"
                          value={item.name}
                          onChange={(e) => {
                            this.getColumnValSale(e);
                          }}
                        />
                        {item.name}
                      </label>
                    </li>
                  ))}
                </ul>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.downloadPngSale();
                  }}
                >
                  Next
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenDownloadModal}
              onHide={this.closeModalDownload}
              className="columnsModal selectColumn downloadImgModal"
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Download as PNG</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.showImageLoader === true && (
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <img
                          src="/edge/images/edgeLoader.gif"
                          className="w100"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {this.state.showImageLoader === false && (
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        {this.state.imgPath ==
                        "You do not have enough privileges to download Data as PNG. Please contact CRE Matrix team for further assistance." ? (
                          <h4>
                            You do not have enough privileges to download Data
                            as PNG. Please contact CRE Matrix team for further
                            assistance.
                          </h4>
                        ) : this.state.imgPath ==
                          "You can select upto 10 columns to export as PNG." ? (
                          <h4>
                            You can select upto 10 columns to export as PNG
                          </h4>
                        ) : (
                          <img src={this.state.imgPath} width={"100%"} />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.downloadPngImg();
                  }}
                >
                  Download
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpenDownloadModalSale}
              onHide={this.closeModalDownloadSale}
              className="columnsModal selectColumn downloadImgModal"
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Download as PNG</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.showImageLoaderSale === true && (
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <img
                          src="/edge/images/edgeLoader.gif"
                          className="w100"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {this.state.showImageLoaderSale === false && (
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-lg-12">
                        {this.state.imgPathSale ==
                        "You do not have enough privileges to download Data as PNG. Please contact CRE Matrix team for further assistance." ? (
                          <h4>
                            You do not have enough privileges to download Data
                            as PNG. Please contact CRE Matrix team for further
                            assistance.
                          </h4>
                        ) : this.state.imgPathSale ==
                          "You can select upto 10 columns to export as PNG." ? (
                          <h4>
                            You can select upto 10 columns to export as PNG
                          </h4>
                        ) : (
                          <img src={this.state.imgPathSale} width={"100%"} />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="ModalSaveBtn"
                  onClick={(e) => {
                    this.downloadPngImgSale();
                  }}
                >
                  Download
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="col-lg-12 text-center">
            <Modal
              show={this.state.isOpenTimeModal}
              onHide={this.closeTimeModal}
              className="columnsModal timeModal transactionTimemachine"
              size="md"
            >
              <Modal.Body style={{ height: "0px" }}>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <DatePicker
                        placeholder="Select Date"
                        value={this.state.startDate}
                        onChange={(date) => this.setDate(date)}
                        defaultOpen={true}
                        preventOverflow={true}
                        placement="auto"
                        oneTap={true}
                        ranges={[]}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          <div className="col-lg-12 text-center">
            <Modal
              show={this.state.isOpenTimeModalSale}
              onHide={this.closeTimeModalSale}
              className="columnsModal timeModal transactionTimemachineSale"
              size="md"
            >
              <Modal.Body>
                {/* <div className="container"> */}
                {/* <div className="row"> */}
                {/* <div className="col-lg-12 text-center"> */}
                <DatePicker
                  placeholder="Select Date"
                  value={this.state.startDateSale}
                  onChange={(date) => this.setDateSale(date)}
                  defaultOpen={true}
                  preventOverflow={true}
                  placement="autoHorizontalStart"
                  oneTap={true}
                  ranges={[]}
                />
                {/* </div> */}
                {/* </div> */}
                {/* </div> */}
              </Modal.Body>
            </Modal>
          </div>
          <div className="col-lg-12 text-center">
            <Modal
              show={this.state.isOpenNotesModal}
              onHide={this.closeNotesModal}
              className="columnsModal timeModal notesModal"
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Notes</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <ol>
                        <li>
                          Carpet/Chargeable area which are not highlighted are
                          as per the area mentioned in the document.
                        </li>
                        <li>
                          Carpet/Chargeable area which are highlighted has been
                          calculated as per the following methodology:
                          <ul style={{ marginTop: "15px" }}>
                            <li>
                              Efficiency of the building is calculated using the
                              weighted average efficiency of the other leases in
                              the building where both the carpet area and
                              chrgeable area has been provided in the lease
                              document. This calculated efficiency is then used
                              to back calculate the missing carpet/chargeable
                              area of the remaining leases in the building.
                            </li>
                            <li>
                              If none of the leases have both the carpet area
                              &amp; chargeable area mentioned in the lease
                              document, in such cases efficiency of the building
                              can't be calculated. For such buildings, we arrive
                              at the efficiency of the building based on market
                              intelligence.
                            </li>
                            <li>
                              If the market intelligence is not available
                              either, we calculate the efficiency based on other
                              leases with the same space type (ex.
                              office/Retail/F&amp;B...) and same
                              micromarket(e.g. BKC Core/Andheri(E)/Nariman
                              Point). This calculated efficiency is then used to
                              back calculate the missing carpet/chargeable area
                              of all the leases in the building.
                            </li>
                            <li>
                              If the efficiency still can't be calculated, the
                              missing values of carpet/chargeable area are left
                              as it is.
                            </li>
                          </ul>
                        </li>
                        <li>
                          Rent per sq ft is calculated based on the total
                          consideration paid by the lessee to the lessor divided
                          by the chargeable area. If chargeable area is not
                          mentioned in the document, carpet area is used.
                        </li>
                        <li>
                          CRE ID: This ID is for referncing a particular lease.
                          If you wish to get more details about a particular
                          lease, please mail to us at info@crematrix.com with
                          CRE ID as the subject of the mail.
                        </li>
                        <li>
                          Security Deposit: If less than or equal to 60 it is in
                          months. Otherwise, it is total Security Deposit
                          Amount.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          <div className="col-lg-12 text-center">
            <Modal
              show={this.state.isOpenErrorDisplayModal}
              onHide={this.closeErrorDisplayModal}
              className="columnsModal timeModal notesModal"
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Notes</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.state.errorMessage,
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          <div className="col-lg-12 text-center">
            <Modal
              show={this.state.isOpenErrorDisplayModalSale}
              onHide={this.closeErrorDisplayModalSale}
              className="columnsModal timeModal notesModal"
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Notes</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.state.errorMessage,
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Transactions);
